import React, { useEffect, useRef, useState } from "react";
import {
  Stack,
  Box,
  Grid,
  Typography,
  useTheme,
  useMediaQuery,
  Button,
} from "@mui/material";
import { useScroll } from "framer-motion";
import Lenis from "@studio-freight/lenis";
import { FaRegCircleCheck } from "react-icons/fa6";
import CTWA from "./svgImage/CWTA.webp";
import From from "./svgImage/Flow.webp";
import Template from "./svgImage/Template.webp";
import Intergration from "./svgImage/Payment.webp";
import Webview from "./svgImage/Webview.webp";
// import Webview from "./svgImage/ayarSirImg.png";
import { FaInfoCircle, FaUserPlus } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { HiMiniCurrencyDollar } from "react-icons/hi2";
import Dollar from "./svgImage/dollar1.png";

const MainCard = () => {
  const container = useRef(null);
  const { scrollYProgress } = useScroll({
    target: container,
    offset: ["start start", "end end"],
  });

  const [scales, setScales] = useState([]);

  // Dynamically calculate scales for each grid item based on scroll progress
  useEffect(() => {
    const unsubscribe = scrollYProgress.onChange((progress) => {
      const newScales = [0, 1, 2, 3, 4].map((i) => {
        return 1 - (5 - i) * 0.05 * progress; // Adjust scaling logic
      });
      setScales(newScales);
    });

    return () => unsubscribe();
  }, [scrollYProgress]);

  useEffect(() => {
    const lenis = new Lenis();

    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }

    requestAnimationFrame(raf);
  }, []);

  const theme = useTheme();
  const navigate = useNavigate();

  const isXs = useMediaQuery(theme.breakpoints.down("xs"));
  const isSm = useMediaQuery(theme.breakpoints.between("xs", "sm"));
  const isMd = useMediaQuery(theme.breakpoints.between("sm", "md"));
  const isLg = useMediaQuery(theme.breakpoints.between("md", "lg"));
  const isXl = useMediaQuery(theme.breakpoints.up("lg"));

  const getIconSize = () => {
    if (isXs) return 12; // Size for xs
    if (isSm) return 12; // Size for sm
    if (isMd) return 12; // Size for md
    if (isLg) return 12; // Size for lg
    if (isXl) return 16; // Size for xl
    return 12; // Default size
  };

  // const getTopValue = () => {
  //   if (isXs || isSm) return 80 + 0 * 35;
  //   return 80 + 0 * 35;
  // };

  const handleClick1 = () => {
    // navigate("/solution1");
    navigate("/solution1", { state: { index: 0 } });
  };
  const handleClick2 = () => {
    // navigate("/card-info");
    navigate("/solution1", { state: { index: 1 } });
  };
  const handleClick3 = () => {
    // navigate("/card-info");
    navigate("/solution1", { state: { index: 2 } });
  };
  const handleClick4 = () => {
    // navigate("/card-info");
    navigate("/solution1", { state: { index: 3 } });
  };
  const handleClick5 = () => {
    // navigate("/card-info");
    navigate("/solution1", { state: { index: 4 } });
  };

  return (
    <Stack
      ref={container}
      sx={{
        display: { xl: "flex", lg: "flex", md: "flex", sm: "flex", xs: "none" },
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Box
        sx={{
          // border: "2px solid red",
          width: {
            lg: "80%",
            xl: "70%",
            md: "85%",
            xs: "90%",
            sm: "100%",
          },
        }}
      >
        <Box
          component="ul"
          sx={{
            //  border: "2px solid red",
            listStyle: "none",
            paddingLeft: 0,
            display: "grid",
            gridTemplateColumns: "1fr",
            gridTemplateRows: "repeat(5, 67vh)",
            gap: "0vw",
            paddingBottom: "calc(4 * 1.5em)",
            marginBottom: "0vw",
          }}
        >
          <Grid
            key={`grid-${0}`}
            component="li"
            sx={{
              //  border: "2px solid red",
              boxSizing: "border-box",
              padding: "30px",
              borderRadius: "20px",
              height: "67vh",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              position: "sticky",
              // top: 80 + 0 * 35, // Adjust top for each grid
              top: isSm ? 40 + 0 * 25 : 70 + 0 * 25,
              backgroundColor: "rgba(255, 255, 255, 0.5)",
              backdropFilter: "blur(8px)",
              boxShadow: "0 8px 32px rgba(0, 0, 0, 0.1)",
              border: "1px solid rgba(255, 255, 255, 0.5)",
              // border: "2px solid red",
              transform: `scale(${scales[0] || 1})`, // Apply dynamic scaling
              transition: "transform 0.1s ease-in-out", // Smooth scaling animation
            }}
          >
            <Box
              sx={{
                //border: "1px solid red",
                backgroundColor: "white",
                width: "100%",
                height: "100%",
              }}
            >
              <Stack
                sx={{
                  width: "100%",
                  height: "100%",

                  display: {
                    lg: "flex",
                    xl: "flex",
                    sm: "flex",
                  },
                  flexDirection: {
                    lg: "row",
                    xl: "row",
                    md: "row",
                    sm: "column",
                  },
                  justifyContent: {
                    lg: "center",
                    xl: "center",
                    sm: "center",
                  },
                  alignItems: {
                    lg: "center",
                    xl: "center",
                    sm: "center",
                  },
                  background: "#F9E8FF", // Gradient background
                }}
              >
                <Stack
                  sx={{
                    backgroundColor: "white",
                    // border: "1px solid blue",
                    height: {
                      lg: "100%",
                      xl: "100%",
                      md: "100%",
                      xs: "60%",
                      sm: "50%",
                      //   xs: "auto",
                      //   sm: "auto",
                    },
                    width: {
                      lg: "40%",
                      xl: "40%",
                      md: "50%",
                      xs: "100%",
                      sm: "100%",
                    },

                    paddingTop: {
                      lg: "0px",
                      xl: "0px",
                      xs: "8px",
                      sm: "12px",
                    },
                  }}
                >
                  <Stack
                    sx={{
                      // border: "1px solid red",
                      height: "100%",
                      marginTop: {
                        lg: "60px",
                        xl: "60px",
                        // md: "0px",
                        xs: "0px",
                        sm: "0px",
                      },
                    }}
                  >
                    <Stack
                      sx={{
                        // border: "1px solid red",
                        height: "auto",
                        lineHeight: {
                          lg: "32px",
                          xl: "40px",
                          md: "32px",
                          xs: "23px",
                          sm: "36px",
                        },
                        fontSize: {
                          lg: "27px",
                          xl: "27px",
                          md: "27px",
                          xs: "18px",
                          sm: "28px",
                        },
                        fontFamily: "'Poppins', sans-serif",
                        fontWeight: "600",
                        // color: "rgba(12, 12, 12, 0.8)",
                        color: "#054E91",
                        paddingLeft: {
                          lg: "40px",
                          xl: "40px",
                          md: "40px",
                          xs: "0px",
                          sm: "40px",
                        },
                        paddingRight: {
                          lg: "40px",
                          xl: "40px",
                          md: "40px",
                          xs: "0px",
                          sm: "40px",
                        },
                        marginBottom: {
                          lg: "20px",
                          xl: "20px",
                          md: "20px",
                          xs: "8px",
                          sm: "8px",
                        },
                        display: "flex",
                        flexDirection: "row",
                        gap: 1,
                      }}
                    >
                      <Stack>
                        <Stack
                          sx={{
                            height: { xl: "100%", lg: "100%", xs: "100%" },
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <Stack
                            sx={{
                              width: { xl: "6px", lg: "6px", xs: "4px" },
                              height: {
                                xl: "63%",
                                lg: "63%",
                                md: "90%",
                                sm: "80%",
                                xs: "93%",
                              },
                              display: "flex",
                              flexDirection: "row",
                              alignItems: "center",
                              // border: "1px solid red",
                              backgroundColor: "rgb(5 78 146)",

                              borderTopRightRadius: "8px", // Adjust the value as needed
                              borderBottomRightRadius: "8px", // Adjust the value as needed
                            }}
                          >
                            <h4 style={{ color: "rgb(5 78 146)" }}>{""}</h4>
                          </Stack>
                        </Stack>
                      </Stack>
                      <span>
                        {" "}
                        One-click chat with{" "}
                        <span style={{ color: "green", fontSize: "27px" }}>
                          WhatsApp
                        </span>
                      </span>
                    </Stack>
                    <Stack
                      sx={{
                        height: "auto",
                        lineHeight: {
                          lg: "25px",
                          xl: "25px",
                          md: "32px",
                          xs: "20px",
                          sm: "20px",
                        },
                        // fontSize: "18px",
                        fontSize: {
                          lg: "20px",
                          xl: "20px",
                          md: "28px",
                          xs: "16px",
                          sm: "20px",
                        },
                        fontFamily: "'Roboto', sans-serif",
                        fontWeight: {
                          lg: "400",
                          xl: "400",
                          xs: "400",
                          sm: "400",
                        },
                        color: "#333",
                        // paddingLeft: "28px",
                        // paddingRight: "28px",
                        paddingLeft: {
                          lg: "28px",
                          xl: "28px",
                          md: "28px",
                          xs: "0px",
                          sm: "28px",
                        },
                        paddingRight: {
                          lg: "28px",
                          xl: "28px",
                          md: "28px",
                          xs: "0px",
                          sm: "28px",
                        },
                        // border: "1px solid blue",
                        marginBottom: {
                          lg: "20px",
                          xl: "20px",
                          md: "20px",
                          xs: "8px",
                          sm: "8px",
                        },
                      }}
                    >
                      <Stack
                        sx={{
                          height: "auto",
                          lineHeight: {
                            lg: "23px",
                            xl: "23px",
                            md: "23px",
                            xs: "20px",
                            sm: "20px",
                          },
                          // fontSize: "18px",
                          fontSize: {
                            lg: "17px",
                            xl: "17px",
                            md: "17px",
                            xs: "16px",
                            sm: "20px",
                          },
                          fontFamily: "'Roboto', sans-serif",
                          fontWeight: {
                            lg: "400",
                            xl: "400",
                            xs: "400",
                            sm: "400",
                          },
                          color: "text.secondary",
                          // paddingLeft: "12px",
                          padding: "12px",
                          // paddingRight: "12px",
                          border: "1px solid rgb(245 241 238))",
                          backgroundColor: "#f0f4e5",
                          borderRadius: "8px",
                          display: {
                            xl: "flex",
                            lg: "flex",
                            md: "flex",
                            sm: "flex",
                            xs: "none",
                          },
                        }}
                      >
                        Engage customers directly through one simple click with
                        CTWA (click to WhatsApp ads).
                      </Stack>

                      <Stack
                        sx={{
                          height: "auto",
                          lineHeight: {
                            lg: "32px",
                            xl: "32px",
                            md: "24px",
                            xs: "20px",
                            sm: "20px",
                          },
                          // fontSize: "18px",
                          fontSize: {
                            lg: "20px",
                            xl: "20px",
                            md: "16px",
                            xs: "16px",
                            sm: "20px",
                          },
                          fontFamily: "'Inter', sans-serif",
                          fontWeight: {
                            lg: "400",
                            xl: "400",
                            xs: "400",
                            sm: "400",
                          },
                          color: "text-secondary",
                          // paddingLeft: "12px",
                          padding: "12px",
                          // paddingRight: "12px",
                          border: "1px solid rgb(218 233 248)",
                          backgroundColor: "rgb(218 233 248)",
                          borderRadius: "8px",
                          display: {
                            xl: "none",
                            lg: "none",
                            md: "none",
                            sm: "none",
                            xs: "flex",
                          },
                        }}
                      >
                        Engage customers directly one simple click to WhatsApp
                        ads.
                      </Stack>
                    </Stack>

                    <Stack
                      sx={{
                        height: "auto",
                        color: "rgb(73, 72, 72)",
                        // paddingLeft: "40px",
                        // paddingRight: "40px",
                        paddingLeft: {
                          lg: "40px",
                          xl: "40px",
                          md: "40px",
                          xs: "12px",
                          sm: "40px",
                        },
                        paddingRight: {
                          lg: "40px",
                          xl: "40px",
                          md: "40px",
                          xs: "12px",
                          sm: "40px",
                        },
                        // border: "1px solid red",
                      }}
                    >
                      <Stack>
                        <Stack
                          sx={{
                            display: {
                              lg: "flex",
                              xl: "flex",
                              md: "flex",
                              xs: "flex",
                              sm: "flex",
                            },
                            flexDirection: "row",
                            marginBottom: {
                              lg: "20px",
                              xl: "20px",
                              md: "12px",
                              xs: "8px",
                              sm: "8px",
                            },
                          }}
                        >
                          <FaRegCircleCheck
                            style={{
                              marginTop: "4px",
                              marginRight: "10px",
                              color: "green",
                            }}
                            size={getIconSize()}
                          />{" "}
                          <Typography
                            sx={{
                              lineHeight: {
                                lg: "24px",
                                xl: "24px",
                                md: "24px",
                                xs: "20px",
                                sm: "28px",
                              },
                              // fontSize: "18px",
                              fontSize: {
                                lg: "16px",
                                xl: "16px",
                                md: "16px",
                                xs: "12px",
                                sm: "16px",
                              },
                              fontFamily: "'Roboto', sans-serif",
                              fontWeight: {
                                lg: "400",
                                xl: "400",
                                xs: "400",
                                sm: "400",
                              },
                              color: "text.secondary",
                            }}
                          >
                            Seamless transition from ads to chat.
                          </Typography>
                        </Stack>
                        <Stack
                          sx={{
                            display: "flex",
                            flexDirection: "row",
                            marginBottom: {
                              lg: "20px",
                              xl: "20px",
                              md: "12px",
                              xs: "8px",
                              sm: "8px",
                            },
                          }}
                        >
                          <FaRegCircleCheck
                            style={{
                              marginTop: "4px",
                              marginRight: "10px",
                              color: "green",
                            }}
                            size={getIconSize()}
                          />{" "}
                          <Typography
                            sx={{
                              lineHeight: {
                                lg: "24px",
                                xl: "24px",
                                md: "24px",
                                xs: "20px",
                                sm: "28px",
                              },
                              display: {
                                xl: "flex",
                                lg: "flex",
                                md: "none",
                                sm: "flex",
                                xs: "flex",
                              },
                              // fontSize: "18px",
                              fontFamily: "'Roboto', sans-serif",
                              fontSize: {
                                lg: "16px",
                                xl: "16px",
                                md: "16px",
                                xs: "12px",
                                sm: "16px",
                              },
                              fontWeight: {
                                lg: "400",
                                xl: "400",
                                xs: "400",
                                sm: "400",
                              },
                              color: "text.secondary",
                            }}
                          >
                            Social media ads redirect to WhatsApp.
                          </Typography>
                          <Typography
                            sx={{
                              lineHeight: {
                                lg: "25px",
                                xl: "25px",
                                md: "20px",
                                xs: "20px",
                                sm: "28px",
                              },
                              display: {
                                xl: "none",
                                lg: "none",
                                md: "flex",
                                sm: "none",
                                xs: "none",
                              },
                              // fontSize: "18px",
                              fontFamily: "'Roboto', sans-serif",
                              fontSize: {
                                lg: "16px",
                                xl: "16px",
                                md: "16px",
                                xs: "12px",
                                sm: "16px",
                              },
                              fontWeight: {
                                lg: "400",
                                xl: "400",
                                xs: "400",
                                sm: "400",
                              },
                            }}
                          >
                            Facebook ads redirect to WhatsApp.
                          </Typography>
                        </Stack>
                        <Stack
                          sx={{
                            display: {
                              xl: "flex",
                              lg: "flex",
                              md: "flex",
                              sm: "flex",
                              xs: "none",
                            },
                            flexDirection: "row",
                            marginBottom: {
                              lg: "20px",
                              xl: "20px",
                              md: "12px",
                              xs: "8px",
                              sm: "8px",
                            },
                          }}
                        >
                          <FaRegCircleCheck
                            style={{
                              marginTop: "4px",
                              marginRight: "10px",
                              color: "green",
                            }}
                            size={getIconSize()}
                          />{" "}
                          <Typography
                            sx={{
                              lineHeight: {
                                lg: "24px",
                                xl: "24px",
                                md: "24px",
                                xs: "20px",
                                sm: "28px",
                              },
                              // fontSize: "18px",
                              fontSize: {
                                lg: "16px",
                                xl: "16px",
                                md: "16px",
                                xs: "12px",
                                sm: "16px",
                              },
                              fontFamily: "'Roboto', sans-serif",
                              fontWeight: {
                                lg: "400",
                                xl: "400",
                                xs: "400",
                                sm: "400",
                              },
                              color: "text.secondary",
                            }}
                          >
                            Boost conversions with direct interaction.
                          </Typography>
                        </Stack>
                        {/* <Stack
                          sx={{
                            display: "flex",
                            flexDirection: "row",
                            marginBottom: {
                              lg: "20px",
                              xl: "20px",
                              md: "12px",
                              xs: "8px",
                              sm: "8px",
                            },
                          }}
                        >
                          <FaRegCircleCheck
                            style={{
                              marginTop: "4px",
                              marginRight: "10px",
                              color: "green",
                            }}
                            size={getIconSize()}
                          />{" "}
                          <Typography
                            sx={{
                              lineHeight: {
                                lg: "25px",
                                xl: "25px",
                                md: "20px",
                                xs: "20px",
                                sm: "28px",
                              },
                              // fontSize: "18px",
                              fontSize: {
                                lg: "16px",
                                xl: "16px",
                                md: "16px",
                                xs: "12px",
                                sm: "16px",
                              },
                              fontFamily: "'Roboto', sans-serif",
                              fontWeight: {
                                lg: "400",
                                xl: "400",
                                xs: "400",
                                sm: "400",
                              },
                            }}
                          >
                            Precise targeting for high ROAS.
                          </Typography>
                        </Stack> */}

                        <Stack
                          sx={{
                            display: {
                              xs: "none", // Hide on extra small screens
                              sm: "none", // Hide on small screens
                              md: "flex", // Show on medium and larger screens
                              lg: "none",
                              xl: "flex",
                            },
                            flexDirection: "row",
                            marginBottom: {
                              lg: "20px",
                              xl: "20px",
                              md: "12px",
                              xs: "8px",
                              sm: "8px",
                            },
                          }}
                        >
                          <FaRegCircleCheck
                            style={{
                              marginTop: "4px",
                              marginRight: "10px",
                              color: "green",
                            }}
                            size={getIconSize()}
                          />{" "}
                          <Typography
                            sx={{
                              lineHeight: {
                                lg: "24px",
                                xl: "24px",
                                md: "24px",
                                xs: "20px",
                                sm: "28px",
                              },
                              // fontSize: "18px",
                              fontFamily: "'Roboto', sans-serif",
                              fontSize: {
                                lg: "16px",
                                xl: "16px",
                                md: "16px",
                                xs: "12px",
                                sm: "16px",
                              },
                              fontWeight: {
                                lg: "400",
                                xl: "400",
                                xs: "400",
                                sm: "400",
                              },
                              color: "text.secondary",
                            }}
                          >
                            Lead generation with WhatsApp chats.
                          </Typography>
                        </Stack>

                        <Stack
                          sx={{
                            display: {
                              xs: "none", // Hide on extra small screens
                              sm: "none", // Hide on small screens
                              md: "flex", // Show on medium and larger screens
                              lg: "none",
                              xl: "flex",
                            },
                            flexDirection: "row",
                            marginBottom: {
                              lg: "20px",
                              xl: "20px",
                              md: "12px",
                              xs: "8px",
                              sm: "8px",
                            },
                          }}
                        >
                          <FaRegCircleCheck
                            style={{
                              marginTop: "4px",
                              marginRight: "10px",
                              color: "green",
                            }}
                            size={getIconSize()}
                          />{" "}
                          <Typography
                            sx={{
                              lineHeight: {
                                lg: "24px",
                                xl: "24px",
                                md: "24px",
                                xs: "20px",
                                sm: "28px",
                              },
                              // fontSize: "18px",
                              fontSize: {
                                lg: "16px",
                                xl: "16px",
                                md: "16px",
                                xs: "12px",
                                sm: "16px",
                              },
                              display: {
                                xl: "flex",
                                lg: "flex",
                                md: "none",
                                sm: "flex",
                                xs: "flex",
                              },
                              fontFamily: "'Roboto', sans-serif",
                              fontWeight: {
                                lg: "400",
                                xl: "400",
                                xs: "400",
                                sm: "400",
                              },
                              color: "text.secondary",
                            }}
                          >
                            Enhance customer journey through WhatsApp.
                          </Typography>
                          <Typography
                            sx={{
                              lineHeight: {
                                lg: "25px",
                                xl: "25px",
                                md: "20px",
                                xs: "20px",
                                sm: "28px",
                              },
                              display: {
                                xl: "none",
                                lg: "none",
                                md: "flex",
                                sm: "none",
                                xs: "none",
                              },
                              // fontSize: "18px",
                              fontSize: {
                                lg: "16px",
                                xl: "16px",
                                md: "16px",
                                xs: "12px",
                                sm: "16px",
                              },
                              fontFamily: "'Roboto', sans-serif",
                              fontWeight: {
                                lg: "400",
                                xl: "400",
                                xs: "400",
                                sm: "400",
                              },
                            }}
                          >
                            Enhance journey through WhatsApp.
                          </Typography>
                        </Stack>
                      </Stack>
                    </Stack>

                    {/* Button */}
                    <Stack
                      sx={{
                        // border: "1px solid red",
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "flex-start",
                        // paddingLeft: "40px",
                        paddingLeft: {
                          lg: "42px",
                          xl: "42px",
                          md: "42px",
                          xs: "12px",
                          sm: "40px",
                        },
                      }}
                    >
                      <Button
                        variant="contained"
                        sx={{
                          display: "flex",
                          textTransform: "none",
                          borderRadius: "8px",
                          backgroundColor: "rgb(5, 78, 146)", // Initial background
                          color: "white", // Text color
                          borderColor: "rgb(5, 78, 146)", // Border same as background
                          boxShadow:
                            "0 4px 8px rgba(0,0,0,0.2), 0 1px 3px rgba(0,0,0,0.1)",

                          "&:hover": {
                            backgroundColor: "rgb(31, 133, 192)", // Hover background
                            borderColor: "rgb(31, 133, 192)", // Hover border
                          },
                        }}
                        size="large"
                        onClick={handleClick1}
                      >
                        Know more
                      </Button>
                    </Stack>
                  </Stack>
                </Stack>
                <Stack
                  sx={{
                    // border: "1px solid green",
                    height: {
                      lg: "100%",
                      xl: "100%",
                      md: "100%",
                      xs: "40%",
                      sm: "50%",
                    },
                    width: {
                      lg: "60%",
                      xl: "60%",
                      md: "50%",
                      xs: "100%",
                      sm: "100%",
                    },
                    backdropFilter: "blur(12px)", // Frosted glass effect
                    // backgroundColor: "rgb(245 241 238)",
                    backgroundColor: "#f0f4e5",
                    overflow: "hidden", // Ensure internal content doesn't overflow
                    position: "relative", // Needed for shine effect
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    transition: "all 0.5s ease-in-out",

                    // Shine Effect
                    // "&::before": {
                    //   content: '""',
                    //   position: "absolute",
                    //   top: 0,
                    //   left: 0,
                    //   width: "100%",
                    //   height: "100%",
                    //   background:
                    //     "linear-gradient(45deg, rgba(255, 255, 255, 0.2) 0%, rgba(255, 255, 255, 0.5) 50%, rgba(255, 255, 255, 0.2) 100%)",
                    //   opacity: 0.6, // Adjust opacity for subtle or prominent shine
                    //   transform: "translate(-100%, -100%)",
                    //   animation: "shineEffect 3s infinite linear",
                    // },
                    // "@keyframes shineEffect": {
                    //   "0%": {
                    //     transform: "translate(-100%, -100%)",
                    //   },
                    //   "100%": {
                    //     transform: "translate(100%, 100%)",
                    //   },
                    // },
                  }}
                >
                  <Stack
                    sx={{
                      height: "100%",
                      width: "100%",
                      //   border: "1px solid green",
                      marginTop: {
                        lg: "0px",
                        xl: "0px",
                        md: "0px",
                        xs: "0px",
                        sm: "0px",
                      },
                    }}
                  >
                    <img
                      src={CTWA}
                      alt="Image1"
                      style={{
                        height: "100%",
                        width: "100%",
                      }}
                    />
                  </Stack>
                </Stack>
              </Stack>
            </Box>
          </Grid>

          <Grid
            key={`grid-${1}`}
            component="li"
            sx={{
              boxSizing: "border-box",
              padding: "30px",
              borderRadius: "20px",
              height: "67vh",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              position: "sticky",
              // top: 80 + 1 * 35, // Adjust top for each grid
              top: isSm ? 40 + 1 * 25 : 70 + 1 * 25,
              backgroundColor: "rgba(255, 255, 255, 0.5)",
              backdropFilter: "blur(8px)",
              boxShadow: "0 8px 32px rgba(0, 0, 0, 0.1)",
              border: "1px solid rgba(255, 255, 255, 0.5)",
              transform: `scale(${scales[1] || 1})`, // Apply dynamic scaling
              transition: "transform 0.1s ease-in-out", // Smooth scaling animation
            }}
          >
            <Box
              sx={{
                backgroundColor: "white",
                width: "100%",
                height: "100%",
              }}
            >
              <Stack
                sx={{
                  width: "100%",
                  height: "100%",

                  display: {
                    lg: "flex",
                    xl: "flex",
                    sm: "flex",
                  },
                  flexDirection: {
                    lg: "row",
                    xl: "row",
                    md: "row",
                    sm: "column",
                  },
                  justifyContent: {
                    lg: "center",
                    xl: "center",
                    sm: "center",
                  },
                  alignItems: {
                    lg: "center",
                    xl: "center",
                    sm: "center",
                  },
                  // background: "linear-gradient(to right, #cce7ff, #f4e3ff)", // Gradient background
                }}
              >
                <Stack
                  sx={{
                    backgroundColor: "white",
                    // border: "1px solid blue",
                    height: {
                      lg: "100%",
                      xl: "100%",
                      md: "100%",
                      xs: "60%",
                      sm: "50%",
                      //   xs: "auto",
                      //   sm: "auto",
                    },
                    width: {
                      lg: "40%",
                      xl: "40%",
                      md: "50%",
                      xs: "100%",
                      sm: "100%",
                    },
                    paddingTop: {
                      lg: "0px",
                      xl: "0px",
                      xs: "8px",
                      sm: "12px",
                    },
                  }}
                >
                  <Stack
                    sx={{
                      height: "100%",
                      marginTop: {
                        lg: "60px",
                        xl: "60px",
                        // md: "0px",
                        xs: "0px",
                        sm: "0px",
                      },
                    }}
                  >
                    <Stack
                      sx={{
                        // border: "1px solid red",
                        height: "auto",
                        // lineHeight: "48px",
                        lineHeight: {
                          lg: "32px",
                          xl: "40px",
                          md: "28px",
                          xs: "23px",
                          sm: "36px",
                        },
                        // fontSize: "39px",
                        fontSize: {
                          lg: "27px",
                          xl: "27px",
                          md: "27px",
                          xs: "18px",
                          sm: "28px",
                        },
                        fontFamily: "'Poppins', sans-serif",
                        fontWeight: "600",
                        // color: "rgba(12, 12, 12, 0.8)",
                        color: "#054E91",
                        // paddingLeft: "40px",
                        // paddingRight: "40px",
                        paddingLeft: {
                          lg: "40px",
                          xl: "40px",
                          md: "40px",
                          xs: "0px",
                          sm: "40px",
                        },
                        paddingRight: {
                          lg: "40px",
                          xl: "40px",
                          md: "40px",
                          xs: "0px",
                          sm: "40px",
                        },
                        marginBottom: {
                          lg: "20px",
                          xl: "20px",
                          md: "20px",
                          xs: "8px",
                          sm: "8px",
                        },
                        display: "flex",
                        flexDirection: "row",
                        gap: 1,
                      }}
                    >
                      <Stack
                        sx={{
                          // border: "1px solid red",
                          height: { xl: "100%", lg: "100%", xs: "100%" },
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <Stack
                          sx={{
                            width: { xl: "6px", lg: "6px", xs: "4px" },
                            height: {
                              xl: "63%",
                              lg: "63%",
                              md: "90%",
                              sm: "80%",
                              xs: "93%",
                            },
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            // border: "1px solid red",
                            backgroundColor: "rgb(5 78 146)",

                            borderTopRightRadius: "8px", // Adjust the value as needed
                            borderBottomRightRadius: "8px", // Adjust the value as needed
                          }}
                        >
                          <h4 style={{ color: "rgb(5 78 146)" }}>{""}</h4>
                        </Stack>
                      </Stack>
                      <span>
                        Interactive{" "}
                        <span style={{ color: "green" }}>WhatsApp forms</span>
                      </span>
                    </Stack>
                    <Stack
                      sx={{
                        height: "auto",
                        lineHeight: {
                          lg: "25px",
                          xl: "25px",
                          md: "32px",
                          xs: "20px",
                          sm: "32px",
                        },
                        // fontSize: "18px",
                        fontSize: {
                          lg: "20px",
                          xl: "20px",
                          md: "28px",
                          xs: "16px",
                          sm: "20px",
                        },
                        fontWeight: {
                          lg: "400",
                          xl: "400",
                          xs: "400",
                          sm: "400",
                        },
                        color: "text-secondary",
                        // paddingLeft: "28px",
                        // paddingRight: "28px",
                        paddingLeft: {
                          lg: "28px",
                          xl: "28px",
                          md: "28px",
                          xs: "0px",
                          sm: "28px",
                        },
                        paddingRight: {
                          lg: "28px",
                          xl: "28px",
                          md: "28px",
                          xs: "0px",
                          sm: "28px",
                        },
                        fontFamily: "'Roboto', sans-serif",
                        // border: "1px solid blue",
                        marginBottom: {
                          lg: "20px",
                          xl: "20px",
                          md: "20px",
                          xs: "8px",
                          sm: "8px",
                        },
                      }}
                    >
                      <Stack
                        sx={{
                          height: "auto",
                          lineHeight: {
                            lg: "21px",
                            xl: "21px",
                            md: "21px",
                            xs: "20px",
                            sm: "32px",
                          },
                          // fontSize: "18px",
                          fontSize: {
                            lg: "17px",
                            xl: "17px",
                            md: "17px",
                            xs: "16px",
                            sm: "20px",
                          },
                          fontFamily: "'Roboto', sans-serif",
                          fontWeight: {
                            lg: "400",
                            xl: "400",
                            xs: "400",
                            sm: "400",
                          },
                          color: "text.secondary",
                          // paddingLeft: "40px",
                          // paddingRight: "40px",
                          padding: "12px",
                          fontFamily: "'Roboto', sans-serif",
                          border: "1px solid rgb(235 229 243)",
                          // backgroundColor: "rgb(235 229 243)",
                          backgroundColor: "#F5EEED",
                          borderRadius: "8px",
                        }}
                      >
                        {/* Simplify customer interactions with smart forms. */}
                        Use smart forms to simplify and speed up customer
                        communication.
                      </Stack>
                    </Stack>

                    <Stack
                      sx={{
                        height: "auto",
                        color: "rgb(73, 72, 72)",
                        // paddingLeft: "40px",
                        // paddingRight: "40px",
                        paddingLeft: {
                          lg: "40px",
                          xl: "40px",
                          md: "40px",
                          xs: "12px",
                          sm: "40px",
                        },
                        paddingRight: {
                          lg: "40px",
                          xl: "40px",
                          md: "40px",
                          xs: "12px",
                          sm: "40px",
                        },
                        // border: "1px solid red",
                      }}
                    >
                      <Stack>
                        <Stack
                          sx={{
                            display: "flex",
                            flexDirection: "row",
                            marginBottom: {
                              lg: "20px",
                              xl: "20px",
                              md: "12px",
                              xs: "8px",
                              sm: "8px",
                            },
                          }}
                        >
                          <FaRegCircleCheck
                            style={{
                              marginTop: "4px",
                              marginRight: "10px",
                              color: "green",
                            }}
                            size={getIconSize()}
                          />{" "}
                          <Typography
                            sx={{
                              lineHeight: {
                                lg: "24px",
                                xl: "24px",
                                md: "24px",
                                xs: "20px",
                                sm: "28px",
                              },
                              // fontSize: "18px",
                              fontSize: {
                                lg: "16px",
                                xl: "16px",
                                md: "16px",
                                xs: "12px",
                                sm: "16px",
                              },
                              fontFamily: "'Roboto', sans-serif",
                              fontWeight: {
                                lg: "400",
                                xl: "400",
                                xs: "400",
                                sm: "400",
                              },
                              color: "text.secondary",
                            }}
                          >
                            Easliy form filling reduce manual effort.
                          </Typography>
                        </Stack>
                        <Stack
                          sx={{
                            display: "flex",
                            flexDirection: "row",
                            marginBottom: {
                              lg: "20px",
                              xl: "20px",
                              md: "12px",
                              xs: "8px",
                              sm: "8px",
                            },
                          }}
                        >
                          <FaRegCircleCheck
                            style={{
                              marginTop: "4px",
                              marginRight: "10px",
                              color: "green",
                            }}
                            size={getIconSize()}
                          />{" "}
                          <Typography
                            sx={{
                              lineHeight: {
                                lg: "24px",
                                xl: "24px",
                                md: "24px",
                                xs: "20px",
                                sm: "28px",
                              },
                              // fontSize: "18px",
                              fontSize: {
                                lg: "16px",
                                xl: "16px",
                                md: "16px",
                                xs: "12px",
                                sm: "16px",
                              },
                              fontFamily: "'Roboto', sans-serif",
                              fontWeight: {
                                lg: "400",
                                xl: "400",
                                xs: "400",
                                sm: "400",
                              },
                              color: "text.secondary",
                            }}
                          >
                            Easily accessible forms on mobile.
                          </Typography>
                        </Stack>
                        <Stack
                          sx={{
                            display: {
                              xl: "flex",
                              lg: "flex",
                              md: "flex",
                              sm: "flex",
                              xs: "none",
                            },
                            flexDirection: "row",
                            marginBottom: {
                              lg: "20px",
                              xl: "20px",
                              md: "12px",
                              xs: "8px",
                              sm: "8px",
                            },
                          }}
                        >
                          <FaRegCircleCheck
                            style={{
                              marginTop: "4px",
                              marginRight: "10px",
                              color: "green",
                            }}
                            size={getIconSize()}
                          />{" "}
                          <Typography
                            sx={{
                              lineHeight: {
                                lg: "24px",
                                xl: "24px",
                                md: "24px",
                                xs: "20px",
                                sm: "28px",
                              },
                              // fontSize: "18px",
                              fontSize: {
                                lg: "16px",
                                xl: "16px",
                                md: "16px",
                                xs: "12px",
                                sm: "16px",
                              },
                              fontFamily: "'Roboto', sans-serif",
                              fontWeight: {
                                lg: "400",
                                xl: "400",
                                xs: "400",
                                sm: "400",
                              },
                              color: "text.secondary",
                            }}
                          >
                            Quickly submit details without hassle.
                          </Typography>
                        </Stack>

                        <Stack
                          sx={{
                            display: "flex",
                            flexDirection: "row",
                            marginBottom: {
                              lg: "20px",
                              xl: "20px",
                              md: "12px",
                              xs: "8px",
                              sm: "8px",
                            },
                          }}
                        >
                          <FaRegCircleCheck
                            style={{
                              marginTop: "4px",
                              marginRight: "10px",
                              color: "green",
                            }}
                            size={getIconSize()}
                          />{" "}
                          <Typography
                            sx={{
                              lineHeight: {
                                lg: "24px",
                                xl: "24px",
                                md: "24px",
                                xs: "20px",
                                sm: "28px",
                              },
                              // fontSize: "18px",
                              fontSize: {
                                lg: "16px",
                                xl: "16px",
                                md: "16px",
                                xs: "12px",
                                sm: "16px",
                              },
                              fontFamily: "'Roboto', sans-serif",
                              fontWeight: {
                                lg: "400",
                                xl: "400",
                                xs: "400",
                                sm: "400",
                              },
                              color: "text.secondary",
                            }}
                          >
                            Fill forms directly within WhatsApp.
                          </Typography>
                        </Stack>

                        <Stack
                          sx={{
                            display: {
                              xs: "none", // Hide on extra small screens
                              sm: "none", // Hide on small screens
                              md: "flex", // Show on medium and larger screens
                              lg: "none",
                              xl: "flex",
                            },
                            flexDirection: "row",
                            marginBottom: {
                              lg: "20px",
                              xl: "20px",
                              md: "12px",
                              xs: "8px",
                              sm: "8px",
                            },
                          }}
                        >
                          <FaRegCircleCheck
                            style={{
                              marginTop: "4px",
                              marginRight: "10px",
                              color: "green",
                            }}
                            size={getIconSize()}
                          />{" "}
                          <Typography
                            sx={{
                              lineHeight: {
                                lg: "24px",
                                xl: "24px",
                                md: "24px",
                                xs: "20px",
                                sm: "28px",
                              },
                              // fontSize: "18px",
                              fontSize: {
                                lg: "16px",
                                xl: "16px",
                                md: "16px",
                                xs: "12px",
                                sm: "16px",
                              },
                              fontFamily: "'Roboto', sans-serif",
                              fontWeight: {
                                lg: "400",
                                xl: "400",
                                xs: "400",
                                sm: "400",
                              },
                              color: "text.secondary",
                              // display: {
                              //   xs: "none", // Hide on extra small screens
                              //   sm: "none", // Hide on small screens
                              //   md: "flex", // Show on medium and larger screens
                              //   lg: "none",
                              //   xl: "flex",
                              // },
                            }}
                          >
                            Boost lead generation with real-time forms.
                          </Typography>
                        </Stack>

                        <Stack
                          sx={{
                            display: {
                              xs: "none", // Hide on extra small screens
                              sm: "none", // Hide on small screens
                              md: "flex", // Show on medium and larger screens
                              lg: "none",
                              xl: "flex",
                            },
                            flexDirection: "row",
                            marginBottom: {
                              lg: "2px",
                              xl: "2px",
                              md: "2px",
                              xs: "8px",
                              sm: "8px",
                            },
                          }}
                        ></Stack>
                      </Stack>
                    </Stack>

                    {/* Button */}
                    <Stack
                      sx={{
                        // border: "1px solid red",
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "flex-start",
                        // paddingLeft: "40px",
                        paddingLeft: {
                          lg: "42px",
                          xl: "42px",
                          md: "42px",
                          xs: "12px",
                          sm: "40px",
                        },
                      }}
                    >
                      <Button
                        variant="contained"
                        sx={{
                          display: "flex",
                          textTransform: "none",
                          borderRadius: "8px",
                          backgroundColor: "rgb(5, 78, 146)", // Initial background
                          color: "white", // Text color
                          borderColor: "rgb(5, 78, 146)", // Border same as background
                          boxShadow:
                            "0 4px 8px rgba(0,0,0,0.2), 0 1px 3px rgba(0,0,0,0.1)",

                          "&:hover": {
                            backgroundColor: "rgb(31, 133, 192)", // Hover background
                            borderColor: "rgb(31, 133, 192)", // Hover border
                          },
                        }}
                        size="large"
                        onClick={handleClick2}
                      >
                        Know more
                      </Button>
                    </Stack>
                  </Stack>
                </Stack>
                <Stack
                  sx={{
                    // border: "1px solid green",
                    height: {
                      lg: "100%",
                      xl: "100%",
                      md: "100%",
                      xs: "40%",
                      sm: "50%",
                    },
                    width: {
                      lg: "60%",
                      xl: "60%",
                      md: "50%",
                      xs: "100%",
                      sm: "100%",
                    },

                    backdropFilter: "blur(12px)",
                    backgroundColor: "#F5EEED",
                    overflow: "hidden",
                    position: "relative",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    transition: "all 0.5s ease-in-out",
                  }}
                >
                  <Stack
                    sx={{
                      height: "100%",
                      width: "100%",
                      // border: "2px solid green",
                      marginTop: {
                        lg: "0px",
                        xl: "0px",
                        md: "0px",
                        xs: "0px",
                        sm: "0px",
                      },
                    }}
                  >
                    <img
                      src={From}
                      alt="Image1"
                      style={{
                        height: "100%",
                        width: "100%",
                        // border: "1px solid red",
                      }}
                    />
                  </Stack>
                </Stack>
              </Stack>
            </Box>
          </Grid>

          <Grid
            key={`grid-${2}`}
            component="li"
            sx={{
              boxSizing: "border-box",
              padding: "30px",
              borderRadius: "20px",
              height: "67vh",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              position: "sticky",
              // top: 80 + 2 * 35, // Adjust top for each grid
              top: isSm ? 40 + 2 * 25 : 70 + 2 * 25,
              backgroundColor: "rgba(255, 255, 255, 0.5)",
              backdropFilter: "blur(8px)",
              boxShadow: "0 8px 32px rgba(0, 0, 0, 0.1)",
              border: "1px solid rgba(255, 255, 255, 0.5)",
              transform: `scale(${scales[2] || 1})`, // Apply dynamic scaling
              transition: "transform 0.1s ease-in-out", // Smooth scaling animation
            }}
          >
            <Box
              sx={{
                backgroundColor: "white",
                width: "100%",
                height: "100%",
                // border: "1px solid red",
              }}
            >
              <Stack
                sx={{
                  width: "100%",
                  height: "100%",

                  display: {
                    lg: "flex",
                    xl: "flex",
                    sm: "flex",
                  },
                  flexDirection: {
                    lg: "row",
                    xl: "row",
                    md: "row",
                    sm: "column",
                  },
                  justifyContent: {
                    lg: "center",
                    xl: "center",
                    sm: "center",
                  },
                  alignItems: {
                    lg: "center",
                    xl: "center",
                    sm: "center",
                  },
                  // background: "linear-gradient(to right, #cce7ff, #f4e3ff)", // Gradient background
                  background: "#E1E5FF", // Gradient background
                }}
              >
                <Stack
                  sx={{
                    backgroundColor: "white",
                    // border: "1px solid blue",
                    height: {
                      lg: "100%",
                      xl: "100%",
                      md: "100%",
                      xs: "60%",
                      sm: "50%",
                      //   xs: "auto",
                      //   sm: "auto",
                    },
                    width: {
                      lg: "40%",
                      xl: "40%",
                      md: "50%",
                      xs: "100%",
                      sm: "100%",
                    },

                    paddingTop: {
                      lg: "0px",
                      xl: "0px",
                      xs: "8px",
                      sm: "12px",
                    },
                  }}
                >
                  <Stack
                    sx={{
                      height: "100%",
                      marginTop: {
                        lg: "60px",
                        xl: "60px",
                        // md: "0px",
                        xs: "0px",
                        sm: "0px",
                      },
                    }}
                  >
                    <Stack
                      sx={{
                        // border: "1px solid red",
                        height: "auto",
                        // lineHeight: "48px",
                        lineHeight: {
                          lg: "32px",
                          xl: "40px",
                          md: "32px",
                          xs: "23px",
                          sm: "36px",
                        },
                        // fontSize: "39px",
                        fontSize: {
                          lg: "27px",
                          xl: "27px",
                          md: "27px",
                          xs: "18px",
                          sm: "28px",
                        },
                        fontFamily: "'Poppins', sans-serif",
                        fontWeight: "600",
                        // color: "rgba(12, 12, 12, 0.8)",
                        color: "#054E91",
                        // paddingLeft: "40px",
                        // paddingRight: "40px",
                        paddingLeft: {
                          lg: "40px",
                          xl: "40px",
                          md: "40px",
                          xs: "0px",
                          sm: "40px",
                        },
                        paddingRight: {
                          lg: "40px",
                          xl: "40px",
                          md: "40px",
                          xs: "0px",
                          sm: "40px",
                        },
                        fontFamily: "'Roboto', sans-serif",
                        marginBottom: {
                          lg: "20px",
                          xl: "20px",
                          md: "20px",
                          xs: "8px",
                          sm: "8px",
                        },
                        display: "flex",
                        flexDirection: "row",
                        gap: 1,
                      }}
                    >
                      <Stack
                        sx={{
                          // border: "1px solid red",
                          height: { xl: "100%", lg: "100%", xs: "100%" },
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <Stack
                          sx={{
                            width: { xl: "6px", lg: "6px", xs: "4px" },
                            height: {
                              xl: "63%",
                              lg: "63%",
                              md: "90%",
                              sm: "80%",
                              xs: "93%",
                            },
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            // border: "1px solid red",
                            backgroundColor: "rgb(5 78 146)",

                            borderTopRightRadius: "8px", // Adjust the value as needed
                            borderBottomRightRadius: "8px", // Adjust the value as needed
                          }}
                        >
                          <h4 style={{ color: "rgb(5 78 146)" }}>{""}</h4>
                        </Stack>
                      </Stack>
                      <span>
                        {" "}
                        Simplify chats using{" "}
                        <span style={{ color: "green" }}>templates</span>
                      </span>
                    </Stack>
                    <Stack
                      sx={{
                        height: "auto",
                        lineHeight: {
                          lg: "25px",
                          xl: "25px",
                          md: "24px",
                          xs: "20px",
                          sm: "32px",
                        },
                        // fontSize: "18px",
                        fontSize: {
                          lg: "20px",
                          xl: "20px",
                          md: "20px",
                          xs: "16px",
                          sm: "20px",
                        },
                        fontWeight: {
                          lg: "400",
                          xl: "400",
                          xs: "400",
                          sm: "400",
                        },
                        color: "text-secondary",
                        // paddingLeft: "28px",
                        // paddingRight: "28px",
                        paddingLeft: {
                          lg: "28px",
                          xl: "28px",
                          md: "28px",
                          xs: "0px",
                          sm: "28px",
                        },
                        paddingRight: {
                          lg: "28px",
                          xl: "28px",
                          md: "28px",
                          xs: "0px",
                          sm: "28px",
                        },
                        // border: "1px solid blue",
                        fontFamily: "'Roboto', sans-serif",
                        marginBottom: {
                          lg: "20px",
                          xl: "20px",
                          md: "12px",
                          xs: "8px",
                          sm: "8px",
                        },
                      }}
                    >
                      <Stack
                        sx={{
                          height: "auto",
                          lineHeight: {
                            lg: "23px",
                            xl: "23px",
                            md: "23px",
                            xs: "20px",
                            sm: "32px",
                          },
                          // fontSize: "18px",
                          fontSize: {
                            lg: "17px",
                            xl: "17px",
                            md: "17px",
                            xs: "16px",
                            sm: "20px",
                          },
                          fontFamily: "'Roboto', sans-serif",
                          fontWeight: {
                            lg: "400",
                            xl: "400",
                            xs: "400",
                            sm: "400",
                          },
                          color: "text.secondary",
                          // paddingLeft: "40px",
                          padding: "12px",
                          // paddingRight: "40px",
                          border: "1px solid rgb(232 242 254)",
                          backgroundColor: "rgb(232 242 254)",
                          borderRadius: "8px",
                          fontFamily: "'Roboto', sans-serif",
                        }}
                      >
                        Simplify communication with pre-designed templates.
                      </Stack>
                    </Stack>

                    <Stack
                      sx={{
                        height: "auto",
                        color: "rgb(73, 72, 72)",
                        // paddingLeft: "40px",
                        // paddingRight: "40px",
                        paddingLeft: {
                          lg: "40px",
                          xl: "40px",
                          md: "40px",
                          xs: "12px",
                          sm: "40px",
                        },
                        paddingRight: {
                          lg: "40px",
                          xl: "40px",
                          md: "40px",
                          xs: "12px",
                          sm: "40px",
                        },
                        //border: "1px solid red",
                      }}
                    >
                      <Stack>
                        <Stack
                          sx={{
                            display: "flex",
                            flexDirection: "row",
                            marginBottom: {
                              lg: "20px",
                              xl: "20px",
                              md: "12px",
                              xs: "8px",
                              sm: "8px",
                            },
                          }}
                        >
                          <FaRegCircleCheck
                            style={{
                              marginTop: "4px",
                              marginRight: "10px",
                              color: "green",
                            }}
                            size={getIconSize()}
                          />{" "}
                          <Typography
                            sx={{
                              lineHeight: {
                                lg: "24px",
                                xl: "24px",
                                md: "24px",
                                xs: "20px",
                                sm: "28px",
                              },
                              display: {
                                xl: "flex",
                                lg: "flex",
                                md: "none",
                                sm: "flex",
                                xs: "none",
                              },
                              // fontSize: "18px",
                              fontSize: {
                                lg: "16px",
                                xl: "16px",
                                md: "16px",
                                xs: "12px",
                                sm: "16px",
                              },
                              fontFamily: "'Roboto', sans-serif",
                              fontWeight: {
                                lg: "400",
                                xl: "400",
                                xs: "400",
                                sm: "400",
                              },
                              color: "text.secondary",
                            }}
                          >
                            Showcase products in a carousel format.
                          </Typography>
                          <Typography
                            sx={{
                              lineHeight: {
                                lg: "25px",
                                xl: "25px",
                                md: "20px",
                                xs: "20px",
                                sm: "28px",
                              },
                              // fontSize: "18px",
                              fontSize: {
                                lg: "16px",
                                xl: "16px",
                                md: "16px",
                                xs: "12px",
                                sm: "16px",
                              },
                              display: {
                                xl: "none",
                                lg: "none",
                                md: "flex",
                                sm: "none",
                                xs: "flex",
                              },

                              fontFamily: "'Roboto', sans-serif",
                              fontWeight: {
                                lg: "400",
                                xl: "400",
                                xs: "400",
                                sm: "400",
                              },
                            }}
                          >
                            Products via carousel messages.
                          </Typography>
                        </Stack>
                        {/* <Stack
                          sx={{
                            display: {
                              xl: "flex",
                              lg: "flex",
                              md: "none",
                              sm: "flex",
                              xs: "none",
                            },
                            flexDirection: "row",
                            marginBottom: {
                              lg: "20px",
                              xl: "20px",
                              md: "12px",
                              xs: "8px",
                              sm: "8px",
                            },
                          }}
                        >
                          <FaRegCircleCheck
                            style={{
                              marginTop: "4px",
                              marginRight: "10px",
                              color: "green",
                            }}
                            size={getIconSize()}
                          />{" "}
                          <Typography
                            sx={{
                              lineHeight: {
                                lg: "25px",
                                xl: "25px",
                                md: "20px",
                                xs: "20px",
                                sm: "28px",
                              },
                              // fontSize: "18px",
                              fontSize: {
                                lg: "16px",
                                xl: "16px",
                                md: "16px",
                                xs: "12px",
                                sm: "16px",
                              },

                              fontFamily: "'Roboto', sans-serif",
                              fontWeight: {
                                lg: "400",
                                xl: "400",
                                xs: "400",
                                sm: "400",
                              },
                              display: {
                                xl: "flex",
                                lg: "flex",
                                md: "flex",
                                sm: "flex",
                                xs: "none",
                              },
                            }}
                          >
                            Promote limited-time offers with call-to-action.
                          </Typography>
                        </Stack> */}
                        <Stack
                          sx={{
                            display: "flex",
                            flexDirection: "row",
                            marginBottom: {
                              lg: "20px",
                              xl: "20px",
                              md: "12px",
                              xs: "8px",
                              sm: "8px",
                            },
                          }}
                        >
                          <FaRegCircleCheck
                            style={{
                              marginTop: "4px",
                              marginRight: "10px",
                              color: "green",
                            }}
                            size={getIconSize()}
                          />{" "}
                          <Typography
                            sx={{
                              lineHeight: {
                                lg: "24px",
                                xl: "24px",
                                md: "24px",
                                xs: "20px",
                                sm: "28px",
                              },
                              // fontSize: "18px",
                              fontSize: {
                                lg: "16px",
                                xl: "16px",
                                md: "16px",
                                xs: "12px",
                                sm: "16px",
                              },
                              fontFamily: "'Roboto', sans-serif",
                              fontWeight: {
                                lg: "400",
                                xl: "400",
                                xs: "400",
                                sm: "400",
                              },
                              color: "text.secondary",
                            }}
                          >
                            Share catalog for easy browsing.
                          </Typography>
                        </Stack>

                        <Stack
                          sx={{
                            display: {
                              xl: "flex",
                              lg: "flex",
                              md: "flex",
                              sm: "flex",
                              xs: "none",
                            },
                            flexDirection: "row",
                            marginBottom: {
                              lg: "20px",
                              xl: "20px",
                              md: "12px",
                              xs: "8px",
                              sm: "8px",
                            },
                          }}
                        >
                          <FaRegCircleCheck
                            style={{
                              marginTop: "4px",
                              marginRight: "10px",
                              color: "green",
                            }}
                            size={getIconSize()}
                          />{" "}
                          <Typography
                            sx={{
                              lineHeight: {
                                lg: "24px",
                                xl: "24px",
                                md: "24px",
                                xs: "20px",
                                sm: "28px",
                              },
                              // fontSize: "18px",
                              fontSize: {
                                lg: "16px",
                                xl: "16px",
                                md: "16px",
                                xs: "12px",
                                sm: "16px",
                              },
                              fontFamily: "'Roboto', sans-serif",
                              fontWeight: {
                                lg: "400",
                                xl: "400",
                                xs: "400",
                                sm: "400",
                              },
                              color: "text.secondary",
                            }}
                          >
                            Send checkout reminders for abandoned carts.
                          </Typography>
                        </Stack>

                        <Stack
                          sx={{
                            display: "flex",
                            flexDirection: "row",
                            marginBottom: {
                              lg: "20px",
                              xl: "20px",
                              md: "12px",
                              xs: "8px",
                              sm: "8px",
                            },
                          }}
                        >
                          <FaRegCircleCheck
                            style={{
                              marginTop: "4px",
                              marginRight: "10px",
                              color: "green",
                            }}
                            size={getIconSize()}
                          />{" "}
                          <Typography
                            sx={{
                              lineHeight: {
                                lg: "24px",
                                xl: "24px",
                                md: "24px",
                                xs: "20px",
                                sm: "28px",
                              },
                              // fontSize: "18px",
                              fontSize: {
                                lg: "16px",
                                xl: "16px",
                                md: "16px",
                                xs: "12px",
                                sm: "16px",
                              },
                              fontFamily: "'Roboto', sans-serif",
                              fontWeight: {
                                lg: "400",
                                xl: "400",
                                xs: "400",
                                sm: "400",
                              },
                              color: "text.secondary",
                            }}
                          >
                            Deliver exclusive discount coupons.
                          </Typography>
                        </Stack>

                        {/* <Stack
                          sx={{
                            display: "flex",
                            flexDirection: "row",
                            marginBottom: {
                              lg: "20px",
                              xl: "20px",
                              md: "12px",
                              xs: "8px",
                              sm: "8px",
                            },
                          }}
                        >
                          <FaRegCircleCheck
                            style={{
                              marginTop: "4px",
                              marginRight: "10px",
                              color: "green",
                            }}
                            size={getIconSize()}
                          />{" "}
                          <Typography
                            sx={{
                              lineHeight: {
                                lg: "25px",
                                xl: "25px",
                                md: "20px",
                                xs: "20px",
                                sm: "28px",
                              },
                              // fontSize: "18px",
                              fontSize: {
                                lg: "16px",
                                xl: "16px",
                                md: "16px",
                                xs: "12px",
                                sm: "16px",
                              },
                              fontFamily: "'Roboto', sans-serif",
                              fontWeight: {
                                lg: "400",
                                xl: "400",
                                xs: "400",
                                sm: "400",
                              },
                            }}
                          >
                             Promote limited-time offers with call-to-action.
                          </Typography>
                        </Stack> */}
                      </Stack>
                    </Stack>
                    <Stack
                      sx={{
                        // border: "1px solid red",
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "flex-start",
                        // paddingLeft: "40px",
                        paddingLeft: {
                          lg: "42px",
                          xl: "42px",
                          md: "42px",
                          xs: "12px",
                          sm: "40px",
                        },
                      }}
                    >
                      <Button
                        variant="contained"
                        sx={{
                          display: "flex",
                          textTransform: "none",
                          borderRadius: "8px",
                          backgroundColor: "rgb(5, 78, 146)", // Initial background
                          color: "white", // Text color
                          borderColor: "rgb(5, 78, 146)", // Border same as background
                          boxShadow:
                            "0 4px 8px rgba(0,0,0,0.2), 0 1px 3px rgba(0,0,0,0.1)",

                          "&:hover": {
                            backgroundColor: "rgb(31, 133, 192)", // Hover background
                            borderColor: "rgb(31, 133, 192)", // Hover border
                          },
                        }}
                        size="large"
                        onClick={handleClick3}
                      >
                        Know more
                      </Button>
                    </Stack>
                  </Stack>
                </Stack>
                {/* images */}
                <Stack
                  sx={{
                    // border: "1px solid green",
                    height: {
                      lg: "100%",
                      xl: "100%",
                      md: "100%",
                      xs: "40%",
                      sm: "50%",
                    },
                    width: {
                      lg: "60%",
                      xl: "60%",
                      md: "50%",
                      xs: "100%",
                      sm: "100%",
                    },

                    // borderRadius: "20px", // Rounded corners for a smooth look
                    backdropFilter: "blur(12px)", // Frosted glass effect
                    backgroundColor: "rgb(232 242 254)",
                    // boxShadow: "0 8px 32px rgba(0, 0, 0, 0.2)", // Soft shadow for depth
                    // border: "1px solid rgba(255, 255, 255, 0.2)", // Subtle border for separation
                    overflow: "hidden", // Ensure internal content doesn't overflow
                    position: "relative", // Needed for shine effect
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    transition: "all 0.5s ease-in-out",

                    // Shine Effect
                    // "&::before": {
                    //   content: '""',
                    //   position: "absolute",
                    //   top: 0,
                    //   left: 0,
                    //   width: "100%",
                    //   height: "100%",
                    //   background:
                    //     "linear-gradient(45deg, rgba(255, 255, 255, 0.2) 0%, rgba(255, 255, 255, 0.5) 50%, rgba(255, 255, 255, 0.2) 100%)",
                    //   opacity: 0.6, // Adjust opacity for subtle or prominent shine
                    //   transform: "translate(-100%, -100%)",
                    //   animation: "shineEffect 3s infinite linear",
                    // },
                    // "@keyframes shineEffect": {
                    //   "0%": {
                    //     transform: "translate(-100%, -100%)",
                    //   },
                    //   "100%": {
                    //     transform: "translate(100%, 100%)",
                    //   },
                    // },
                    // marginTop: {
                    //   lg: "0px",
                    //   xl: "0px",
                    //   md: "0px",
                    //   xs: "80px",
                    //   sm: "0px",
                    // },
                  }}
                >
                  <Stack
                    sx={{
                      height: "100%",
                      width: "100%",
                      //   border: "1px solid green",
                      marginTop: {
                        lg: "0px",
                        xl: "0px",
                        md: "0px",
                        xs: "0px",
                        sm: "0px",
                      },
                    }}
                  >
                    <img
                      src={Template}
                      alt="Image1"
                      style={{
                        height: "100%",
                        width: "100%",
                      }}
                    />
                  </Stack>
                </Stack>
              </Stack>
            </Box>
          </Grid>

          <Grid
            key={`grid-${3}`}
            component="li"
            sx={{
              boxSizing: "border-box",
              padding: "30px",
              borderRadius: "20px",
              height: "67vh",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              position: "sticky",
              // top: 80 + 3 * 35, // Adjust top for each grid
              top: isSm ? 40 + 3 * 25 : 70 + 3 * 25,
              backgroundColor: "rgba(255, 255, 255, 0.5)",
              backdropFilter: "blur(8px)",
              boxShadow: "0 8px 32px rgba(0, 0, 0, 0.1)",
              border: "1px solid rgba(255, 255, 255, 0.5)",
              transform: `scale(${scales[3] || 1})`, // Apply dynamic scaling
              transition: "transform 0.1s ease-in-out", // Smooth scaling animation
            }}
          >
            <Box
              sx={{
                backgroundColor: "white",
                width: "100%",
                height: "100%",
                // border: "1px solid red",
              }}
            >
              <Stack
                sx={{
                  width: "100%",
                  height: "100%",

                  display: {
                    lg: "flex",
                    xl: "flex",
                    sm: "flex",
                  },
                  flexDirection: {
                    lg: "row",
                    xl: "row",
                    md: "row",
                    sm: "column",
                  },
                  justifyContent: {
                    lg: "center",
                    xl: "center",
                    sm: "center",
                  },
                  alignItems: {
                    lg: "center",
                    xl: "center",
                    sm: "center",
                  },
                  // background: "linear-gradient(to right, #cce7ff, #f4e3ff)", // Gradient background
                  background: "#D9FAFF", // Gradient background
                }}
              >
                <Stack
                  sx={{
                    backgroundColor: "white",
                    // border: "1px solid blue",
                    height: {
                      lg: "100%",
                      xl: "100%",
                      md: "100%",
                      xs: "60%",
                      sm: "50%",
                      //   xs: "auto",
                      //   sm: "auto",
                    },
                    width: {
                      lg: "40%",
                      xl: "40%",
                      md: "50%",
                      xs: "100%",
                      sm: "100%",
                    },

                    paddingTop: {
                      lg: "0px",
                      xl: "0px",
                      xs: "8px",
                      sm: "12px",
                    },
                  }}
                >
                  <Stack
                    sx={{
                      height: "100%",
                      marginTop: {
                        lg: "60px",
                        xl: "60px",
                        // md: "0px",
                        xs: "0px",
                        sm: "0px",
                      },
                    }}
                  >
                    <Stack
                      sx={{
                        // border: "1px solid red",
                        height: "auto",
                        // lineHeight: "48px",
                        lineHeight: {
                          lg: "32px",
                          xl: "40px",
                          md: "32px",
                          xs: "23px",
                          sm: "36px",
                        },
                        // fontSize: "39px",
                        fontSize: {
                          lg: "27px",
                          xl: "27px",
                          md: "27px",
                          xs: "18px",
                          sm: "28px",
                        },
                        fontFamily: "'Poppins', sans-serif",
                        fontWeight: "600",
                        // color: "rgba(12, 12, 12, 0.8)",
                        color: "#054E91",
                        paddingLeft: {
                          lg: "40px",
                          xl: "40px",
                          md: "40px",
                          xs: "0px",
                          sm: "40px",
                        },
                        paddingRight: {
                          lg: "40px",
                          xl: "40px",
                          md: "40px",
                          xs: "0px",
                          sm: "40px",
                        },
                        fontFamily: "'Roboto', sans-serif",
                        marginBottom: {
                          lg: "20px",
                          xl: "20px",
                          md: "12px",
                          xs: "8px",
                          sm: "8px",
                        },
                        display: "flex",
                        flexDirection: "row",
                        gap: 1,
                      }}
                    >
                      <Stack
                        sx={{
                          // border: "1px solid red",
                          height: { xl: "100%", lg: "100%", xs: "100%" },
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <Stack
                          sx={{
                            width: { xl: "6px", lg: "6px", xs: "4px" },
                            height: {
                              xl: "63%",
                              lg: "63%",
                              md: "90%",
                              sm: "80%",
                              xs: "93%",
                            },
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            // border: "1px solid red",
                            backgroundColor: "rgb(5 78 146)",

                            borderTopRightRadius: "8px", // Adjust the value as needed
                            borderBottomRightRadius: "8px", // Adjust the value as needed
                          }}
                        >
                          <h4 style={{ color: "rgb(5 78 146)" }}>{""}</h4>
                        </Stack>
                      </Stack>
                      <Stack
                        sx={{
                          display: {
                            xl: "flex",
                            lg: "flex",
                            md: "flex",
                            sm: "flex",
                            xs: "none",
                          },
                        }}
                      >
                        <span>
                          {" "}
                          Accept payments{" "}
                          <span style={{ color: "green" }}> via WhatsApp</span>
                        </span>
                      </Stack>

                      <Stack
                        sx={{
                          display: {
                            xl: "none",
                            lg: "none",
                            md: "none",
                            sm: "none",
                            xs: "flex",
                          },
                        }}
                      >
                        <span>
                          {" "}
                          <span style={{ color: "green" }}>WhatsApp</span>{" "}
                          payment.
                        </span>
                      </Stack>
                    </Stack>
                    <Stack
                      sx={{
                        height: "auto",
                        lineHeight: {
                          lg: "25px",
                          xl: "25px",
                          md: "32px",
                          xs: "20px",
                          sm: "28px",
                        },
                        // fontSize: "18px",
                        fontSize: {
                          lg: "20px",
                          xl: "20px",
                          md: "28px",
                          xs: "16px",
                          sm: "20px",
                        },
                        fontWeight: {
                          lg: "400",
                          xl: "400",
                          xs: "400",
                          sm: "400",
                        },
                        color: "text-secondary",
                        // paddingLeft: "40px",
                        // paddingRight: "40px",
                        paddingLeft: {
                          lg: "28px",
                          xl: "28px",
                          md: "28px",
                          xs: "0px",
                          sm: "28px",
                        },
                        paddingRight: {
                          lg: "28px",
                          xl: "28px",
                          md: "28px",
                          xs: "0px",
                          sm: "28px",
                        },
                        // border: "1px solid blue",
                        fontFamily: "'Roboto', sans-serif",
                        marginBottom: {
                          lg: "20px",
                          xl: "20px",
                          md: "12px",
                          xs: "8px",
                          sm: "8px",
                        },
                      }}
                    >
                      <Stack
                        sx={{
                          height: "auto",
                          lineHeight: {
                            lg: "22px",
                            xl: "22px",
                            md: "22px",
                            xs: "20px",
                            sm: "28px",
                          },
                          // fontSize: "18px",
                          fontSize: {
                            lg: "17px",
                            xl: "17px",
                            md: "17px",
                            xs: "16px",
                            sm: "20px",
                          },
                          fontFamily: "'Roboto', sans-serif",
                          fontWeight: {
                            lg: "400",
                            xl: "400",
                            xs: "400",
                            sm: "400",
                          },
                          color: "text.secondary",
                          // paddingLeft: "40px",
                          // paddingRight: "40px",
                          padding: "12px",
                          border: "1px solid rgb(224 240 241))",
                          backgroundColor: "rgb(224 240 241)",
                          borderRadius: "8px",
                          fontFamily: "'Roboto', sans-serif",
                        }}
                      >
                        Enable seamless, secureand instant payments with ease.
                      </Stack>
                    </Stack>

                    <Stack
                      sx={{
                        height: "auto",
                        color: "rgb(73, 72, 72)",
                        // paddingLeft: "40px",
                        // paddingRight: "40px",
                        paddingLeft: {
                          lg: "40px",
                          xl: "40px",
                          md: "40px",
                          xs: "12px",
                          sm: "40px",
                        },
                        paddingRight: {
                          lg: "40px",
                          xl: "40px",
                          md: "40px",
                          xs: "12px",
                          sm: "40px",
                        },
                        // border: "1px solid red",
                      }}
                    >
                      <Stack>
                        <Stack
                          sx={{
                            display: {
                              xs: "none", // Hide on extra small screens
                              sm: "flex", // Hide on small screens
                              md: "flex", // Show on medium and larger screens
                              lg: "flex",
                              xl: "flex",
                            },
                            flexDirection: "row",
                            marginBottom: {
                              lg: "20px",
                              xl: "20px",
                              md: "12px",
                              xs: "8px",
                              sm: "8px",
                            },
                          }}
                        >
                          <FaRegCircleCheck
                            style={{
                              marginTop: "4px",
                              marginRight: "10px",
                              color: "green",
                            }}
                            size={getIconSize()}
                          />{" "}
                          <Typography
                            sx={{
                              lineHeight: {
                                lg: "24px",
                                xl: "24px",
                                md: "24px",
                                xs: "20px",
                                sm: "28px",
                              },
                              // fontSize: "18px",
                              fontSize: {
                                lg: "16px",
                                xl: "16px",
                                md: "16px",
                                xs: "12px",
                                sm: "16px",
                              },
                              fontFamily: "'Roboto', sans-serif",
                              fontWeight: {
                                lg: "400",
                                xl: "400",
                                xs: "400",
                                sm: "400",
                              },
                              color: "text.secondary",
                            }}
                          >
                            Enable seamless in-chat payment experience.
                          </Typography>
                        </Stack>
                        <Stack
                          sx={{
                            display: "flex",
                            flexDirection: "row",
                            marginBottom: {
                              lg: "20px",
                              xl: "20px",
                              md: "12px",
                              xs: "8px",
                              sm: "8px",
                            },
                          }}
                        >
                          <FaRegCircleCheck
                            style={{
                              marginTop: "4px",
                              marginRight: "10px",
                              color: "green",
                            }}
                            size={getIconSize()}
                          />{" "}
                          <Typography
                            sx={{
                              lineHeight: {
                                lg: "24px",
                                xl: "24px",
                                md: "24px",
                                xs: "20px",
                                sm: "28px",
                              },
                              // fontSize: "18px",
                              fontSize: {
                                lg: "16px",
                                xl: "16px",
                                md: "16px",
                                xs: "12px",
                                sm: "16px",
                              },
                              fontFamily: "'Roboto', sans-serif",
                              fontWeight: {
                                lg: "400",
                                xl: "400",
                                xs: "400",
                                sm: "400",
                              },
                              color: "text.secondary",
                            }}
                          >
                            Offer multiple payment modes to users.
                          </Typography>
                        </Stack>
                        <Stack
                          sx={{
                            display: "flex",
                            flexDirection: "row",
                            marginBottom: {
                              lg: "20px",
                              xl: "20px",
                              md: "12px",
                              xs: "8px",
                              sm: "8px",
                            },
                          }}
                        >
                          <FaRegCircleCheck
                            style={{
                              marginTop: "4px",
                              marginRight: "10px",
                              color: "green",
                            }}
                            size={getIconSize()}
                          />{" "}
                          <Typography
                            sx={{
                              lineHeight: {
                                lg: "24px",
                                xl: "24px",
                                md: "24px",
                                xs: "20px",
                                sm: "28px",
                              },
                              // fontSize: "18px",
                              fontSize: {
                                lg: "16px",
                                xl: "16px",
                                md: "16px",
                                xs: "12px",
                                sm: "16px",
                              },
                              fontFamily: "'Roboto', sans-serif",
                              fontWeight: {
                                lg: "400",
                                xl: "400",
                                xs: "400",
                                sm: "400",
                              },
                              display: {
                                xs: "none", // Hide on extra small screens
                                sm: "flex", // Hide on small screens
                                md: "flex", // Show on medium and larger screens
                                lg: "flex",
                                xl: "flex",
                              },
                              color: "text.secondary",
                            }}
                          >
                            Send instant alerts after payment completion.
                          </Typography>
                          <Typography
                            sx={{
                              lineHeight: {
                                lg: "25px",
                                xl: "25px",
                                md: "20px",
                                xs: "20px",
                                sm: "28px",
                              },
                              // fontSize: "18px",
                              fontSize: {
                                lg: "16px",
                                xl: "16px",
                                md: "16px",
                                xs: "12px",
                                sm: "16px",
                              },
                              fontFamily: "'Roboto', sans-serif",
                              fontWeight: {
                                lg: "400",
                                xl: "400",
                                xs: "400",
                                sm: "400",
                              },
                              display: {
                                xs: "flex", // Hide on extra small screens
                                sm: "none", // Hide on small screens
                                md: "none", // Show on medium and larger screens
                                lg: "none",
                                xl: "none",
                              },
                            }}
                          >
                            Send alerts after payment completion.
                          </Typography>
                        </Stack>
                        {/* <Stack
                          sx={{
                            display: "flex",
                            flexDirection: "row",
                            marginBottom: {
                              lg: "20px",
                              xl: "20px",
                              md: "20px",
                              xs: "8px",
                              sm: "8px",
                            },
                          }}
                        >
                          <FaRegCircleCheck
                            style={{
                              marginTop: "4px",
                              marginRight: "10px",
                              color: "green",
                            }}
                            size={getIconSize()}
                          />{" "}
                          <Typography
                            sx={{
                              lineHeight: {
                                lg: "25px",
                                xl: "25px",
                                md: "34px",
                                xs: "20px",
                                sm: "28px",
                              },
                              // fontSize: "18px",
                              fontSize: {
                                lg: "16px",
                                xl: "16px",
                                md: "24px",
                                xs: "12px",
                                sm: "16px",
                              },
                              fontFamily: "'Roboto', sans-serif",
                              fontWeight: {
                                lg: "400",
                                xl: "400",
                                xs: "400",
                                sm: "400",
                              },
                            }}
                          >
                            Simplify transactions with secure links.
                          </Typography>
                        </Stack> */}

                        <Stack
                          sx={{
                            display: {
                              xs: "none", // Hide on extra small screens
                              sm: "none", // Hide on small screens
                              md: "flex", // Show on medium and larger screens
                              lg: "none",
                              xl: "flex",
                            },
                            flexDirection: "row",
                            marginBottom: {
                              lg: "20px",
                              xl: "20px",
                              md: "12px",
                              xs: "8px",
                              sm: "8px",
                            },
                          }}
                        >
                          <FaRegCircleCheck
                            style={{
                              marginTop: "4px",
                              marginRight: "10px",
                              color: "green",
                            }}
                            size={getIconSize()}
                          />{" "}
                          <Typography
                            sx={{
                              lineHeight: {
                                lg: "24px",
                                xl: "24px",
                                md: "24px",
                                xs: "20px",
                                sm: "28px",
                              },
                              // fontSize: "18px",
                              fontSize: {
                                lg: "16px",
                                xl: "16px",
                                md: "16px",
                                xs: "12px",
                                sm: "16px",
                              },
                              fontFamily: "'Roboto', sans-serif",
                              fontWeight: {
                                lg: "400",
                                xl: "400",
                                xs: "400",
                                sm: "400",
                              },
                              display: {
                                xs: "none", // Hide on extra small screens
                                sm: "none", // Hide on small screens
                                md: "flex", // Show on medium and larger screens
                                lg: "none",
                                xl: "flex",
                              },
                              color: "text.secondary",
                            }}
                          >
                            Ensure secure UPI payment gateway integration.
                          </Typography>
                          {/* <Typography
                            sx={{
                              lineHeight: {
                                lg: "25px",
                                xl: "25px",
                                md: "20px",
                                xs: "20px",
                                sm: "28px",
                              },
                              // fontSize: "18px",
                              fontSize: {
                                lg: "16px",
                                xl: "16px",
                                md: "16px",
                                xs: "12px",
                                sm: "16px",
                              },
                              fontFamily: "'Roboto', sans-serif",
                              fontWeight: {
                                lg: "400",
                                xl: "400",
                                xs: "400",
                                sm: "400",
                              },

                              display: {
                                xs: "flex", // Hide on extra small screens
                                sm: "none", // Hide on small screens
                                md: "none", // Show on medium and larger screens
                                lg: "none",
                                xl: "none",
                              },
                            }}
                          >
                            Secure UPI payment gateway integration.
                          </Typography> */}
                        </Stack>

                        {/* <Stack
                          sx={{
                            // display: {
                            //   xs: "none", // Hide on extra small screens
                            //   sm: "none", // Hide on small screens
                            //   md: "flex", // Show on medium and larger screens
                            //   lg: "none",
                            //   xl: "flex",
                            // },
                            flexDirection: "row",
                            marginBottom: {
                              lg: "20px",
                              xl: "20px",
                              md: "12px",
                              xs: "8px",
                              sm: "8px",
                            },
                          }}
                        >
                          <FaRegCircleCheck
                            style={{
                              marginTop: "4px",
                              marginRight: "10px",
                              color: "green",
                            }}
                            size={getIconSize()}
                          />{" "}
                          <Typography
                            sx={{
                              lineHeight: {
                                lg: "25px",
                                xl: "25px",
                                md: "20px",
                                xs: "20px",
                                sm: "28px",
                              },
                              // fontSize: "18px",
                              fontSize: {
                                lg: "16px",
                                xl: "16px",
                                md: "16px",
                                xs: "12px",
                                sm: "16px",
                              },
                              fontFamily: "'Roboto', sans-serif",
                              fontWeight: {
                                lg: "400",
                                xl: "400",
                                xs: "400",
                                sm: "400",
                              },
                              display: {
                                xs: "none", // Hide on extra small screens
                                sm: "none", // Hide on small screens
                                md: "flex", // Show on medium and larger screens
                                lg: "none",
                                xl: "flex",
                              },
                            }}
                          >
                            Provide detailed order summary with invoice.
                          </Typography>
                          <Typography
                            sx={{
                              lineHeight: {
                                lg: "25px",
                                xl: "25px",
                                md: "20px",
                                xs: "20px",
                                sm: "28px",
                              },
                              // fontSize: "18px",
                              fontSize: {
                                lg: "16px",
                                xl: "16px",
                                md: "16px",
                                xs: "12px",
                                sm: "16px",
                              },
                              fontFamily: "'Roboto', sans-serif",
                              fontWeight: {
                                lg: "400",
                                xl: "400",
                                xs: "400",
                                sm: "400",
                              },
                              display: {
                                xs: "flex", // Hide on extra small screens
                                sm: "none", // Hide on small screens
                                md: "none", // Show on medium and larger screens
                                lg: "none",
                                xl: "none",
                              },
                            }}
                          >
                            Provide order summary with invoice.
                          </Typography>
                        </Stack> */}

                        <Stack
                          sx={{
                            display: {
                              xs: "none", // Hide on extra small screens
                              sm: "none", // Hide on small screens
                              md: "flex", // Show on medium and larger screens
                              lg: "none",
                              xl: "flex",
                            },
                            flexDirection: "row",
                            marginBottom: {
                              lg: "20px",
                              xl: "20px",
                              md: "12px",
                              xs: "8px",
                              sm: "8px",
                            },
                          }}
                        >
                          <FaRegCircleCheck
                            style={{
                              marginTop: "4px",
                              marginRight: "10px",
                              color: "green",
                            }}
                            size={getIconSize()}
                          />{" "}
                          <Typography
                            sx={{
                              lineHeight: {
                                lg: "24px",
                                xl: "24px",
                                md: "24px",
                                xs: "20px",
                                sm: "28px",
                              },
                              // fontSize: "18px",
                              fontSize: {
                                lg: "16px",
                                xl: "16px",
                                md: "16px",
                                xs: "12px",
                                sm: "16px",
                              },
                              fontFamily: "'Roboto', sans-serif",
                              fontWeight: {
                                lg: "400",
                                xl: "400",
                                xs: "400",
                                sm: "400",
                              },
                              display: {
                                xs: "none", // Hide on extra small screens
                                sm: "none", // Hide on small screens
                                md: "flex", // Show on medium and larger screens
                                lg: "none",
                                xl: "flex",
                              },
                              color: "text.secondary",
                            }}
                          >
                            Allow checkout without page redirection.
                          </Typography>
                          <Typography
                            sx={{
                              lineHeight: {
                                lg: "25px",
                                xl: "25px",
                                md: "20px",
                                xs: "20px",
                                sm: "28px",
                              },
                              // fontSize: "18px",
                              fontSize: {
                                lg: "16px",
                                xl: "16px",
                                md: "16px",
                                xs: "12px",
                                sm: "16px",
                              },
                              fontFamily: "'Roboto', sans-serif",
                              fontWeight: {
                                lg: "400",
                                xl: "400",
                                xs: "400",
                                sm: "400",
                              },
                              display: {
                                xs: "none", // Hide on extra small screens
                                sm: "none", // Hide on small screens
                                md: "none", // Show on medium and larger screens
                                lg: "none",
                                xl: "none",
                              },
                            }}
                          >
                            Allow checkout without page redirection.
                          </Typography>
                        </Stack>
                      </Stack>
                    </Stack>
                    <Stack
                      sx={{
                        // border: "1px solid red",
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "flex-start",
                        // paddingLeft: "40px",
                        paddingLeft: {
                          lg: "42px",
                          xl: "42px",
                          md: "42px",
                          xs: "12px",
                          sm: "40px",
                        },
                      }}
                    >
                      <Button
                        variant="contained"
                        sx={{
                          display: "flex",
                          textTransform: "none",
                          borderRadius: "8px",
                          backgroundColor: "rgb(5, 78, 146)", // Initial background
                          color: "white", // Text color
                          borderColor: "rgb(5, 78, 146)", // Border same as background
                          boxShadow:
                            "0 4px 8px rgba(0,0,0,0.2), 0 1px 3px rgba(0,0,0,0.1)",

                          "&:hover": {
                            backgroundColor: "rgb(31, 133, 192)", // Hover background
                            borderColor: "rgb(31, 133, 192)", // Hover border
                          },
                        }}
                        size="large"
                        onClick={handleClick4}
                      >
                        Know more
                      </Button>
                    </Stack>
                  </Stack>
                </Stack>
                {/* image */}
                <Stack
                  sx={{
                    // border: "1px solid green",
                    height: {
                      lg: "100%",
                      xl: "100%",
                      md: "100%",
                      xs: "40%",
                      sm: "50%",
                    },
                    width: {
                      lg: "60%",
                      xl: "60%",
                      md: "50%",
                      xs: "100%",
                      sm: "100%",
                    },

                    // borderRadius: "20px", // Rounded corners for a smooth look
                    backdropFilter: "blur(12px)", // Frosted glass effect
                    backgroundColor: "rgb(224 240 241)",
                    // boxShadow: "0 8px 32px rgba(0, 0, 0, 0.2)", // Soft shadow for depth
                    // border: "1px solid rgba(255, 255, 255, 0.2)", // Subtle border for separation
                    overflow: "hidden", // Ensure internal content doesn't overflow
                    position: "relative", // Needed for shine effect
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    transition: "all 0.5s ease-in-out",
                  }}
                >
                  <Stack
                    sx={{
                      height: "100%",
                      width: "100%",
                      //   border: "1px solid green",
                      marginTop: {
                        lg: "0px",
                        xl: "0px",
                        md: "0px",
                        xs: "0px",
                        sm: "0px",
                      },
                    }}
                  >
                    <img
                      src={Intergration}
                      alt="Image1"
                      style={{
                        height: "100%",
                        width: "100%",
                      }}
                    />
                  </Stack>
                </Stack>
              </Stack>
            </Box>
          </Grid>

          <Grid
            key={`grid-${4}`}
            component="li"
            sx={{
              boxSizing: "border-box",
              padding: "30px",
              borderRadius: "20px",
              height: "67vh",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              position: "sticky",
              // top: 80 + 4 * 35, // Adjust top for each grid
              top: isSm ? 40 + 4 * 25 : 70 + 4 * 25,
              backgroundColor: "rgba(255, 255, 255, 0.5)",
              backdropFilter: "blur(8px)",
              boxShadow: "0 8px 32px rgba(0, 0, 0, 0.1)",
              border: "1px solid rgba(255, 255, 255, 0.5)",
              transform: `scale(${scales[4] || 1})`, // Apply dynamic scaling
              transition: "transform 0.1s ease-in-out", // Smooth scaling animation
            }}
          >
            <Box
              sx={{
                backgroundColor: "white",
                width: "100%",
                height: "100%",
                // border: { md: "1px solid red", sm: "2px solid green" },
              }}
            >
              <Stack
                sx={{
                  width: "100%",
                  height: "100%",

                  display: {
                    lg: "flex",
                    xl: "flex",
                    sm: "flex",
                  },
                  flexDirection: {
                    lg: "row",
                    xl: "row",
                    md: "row",
                    sm: "column",
                  },
                  justifyContent: {
                    lg: "center",
                    xl: "center",
                    sm: "center",
                  },
                  alignItems: {
                    lg: "center",
                    xl: "center",
                    sm: "center",
                  },
                  // background: "linear-gradient(to right, #cce7ff, #f4e3ff)", // Gradient background
                  background: "#FFE0E0",
                }}
              >
                <Stack
                  sx={{
                    backgroundColor: "white",
                    // border: "1px solid blue",
                    height: {
                      lg: "100%",
                      xl: "100%",
                      md: "100%",
                      xs: "60%",
                      sm: "50%",
                      //   xs: "auto",
                      //   sm: "auto",
                    },
                    width: {
                      lg: "40%",
                      xl: "40%",
                      md: "50%",
                      xs: "100%",
                      sm: "100%",
                    },

                    paddingTop: {
                      lg: "0px",
                      xl: "0px",
                      xs: "8px",
                      sm: "12px",
                    },
                  }}
                >
                  <Stack
                    sx={{
                      height: "100%",
                      marginTop: {
                        lg: "60px",
                        xl: "60px",
                        // md: "0px",
                        xs: "0px",
                        sm: "0px",
                      },
                    }}
                  >
                    <Stack
                      sx={{
                        // border: "1px solid red",
                        height: "auto",
                        // lineHeight: "48px",
                        lineHeight: {
                          lg: "32px",
                          xl: "40px",
                          md: "32px",
                          xs: "23px",
                          sm: "36px",
                        },
                        // fontSize: "39px",
                        fontSize: {
                          lg: "27px",
                          xl: "27px",
                          md: "27px",
                          xs: "18px",
                          sm: "28px",
                        },
                        fontFamily: "'Poppins', sans-serif",
                        fontWeight: "600",
                        // color: "rgba(12, 12, 12, 0.8)",
                        color: "#054E91",
                        // paddingLeft: "40px",
                        // paddingRight: "40px",
                        paddingLeft: {
                          lg: "40px",
                          xl: "40px",
                          md: "40px",
                          xs: "0px",
                          sm: "40px",
                        },
                        paddingRight: {
                          lg: "40px",
                          xl: "40px",
                          md: "40px",
                          xs: "0px",
                          sm: "40px",
                        },

                        marginBottom: {
                          lg: "20px",
                          xl: "20px",
                          md: "20px",
                          xs: "8px",
                          sm: "8px",
                        },
                        fontFamily: "'Roboto', sans-serif",
                        display: "flex",
                        flexDirection: "row",
                        gap: 1,
                      }}
                    >
                      <Stack
                        sx={{
                          // border: "1px solid red",
                          height: { xl: "100%", lg: "100%", xs: "100%" },
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <Stack
                          sx={{
                            width: { xl: "6px", lg: "6px", xs: "4px" },
                            height: {
                              xl: "63%",
                              lg: "63%",
                              md: "90%",
                              sm: "80%",
                              xs: "93%",
                            },
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            // border: "1px solid red",
                            backgroundColor: "rgb(5 78 146)",

                            borderTopRightRadius: "8px", // Adjust the value as needed
                            borderBottomRightRadius: "8px", // Adjust the value as needed
                          }}
                        >
                          <h4 style={{ color: "rgb(5 78 146)" }}>{""}</h4>
                        </Stack>
                      </Stack>
                      <Stack>
                        {" "}
                        <span>
                          {" "}
                          In-chat webview{" "}
                          <span style={{ color: "green" }}> on WhatsApp</span>
                        </span>
                      </Stack>
                    </Stack>
                    <Stack
                      sx={{
                        height: "auto",
                        lineHeight: {
                          lg: "32px",
                          xl: "32px",
                          md: "32px",
                          xs: "20px",
                          sm: "32px",
                        },
                        // fontSize: "18px",
                        fontSize: {
                          lg: "20px",
                          xl: "20px",
                          md: "28px",
                          xs: "16px",
                          sm: "20px",
                        },
                        fontWeight: {
                          lg: "400",
                          xl: "400",
                          xs: "400",
                          sm: "400",
                        },
                        color: "text-secondary",
                        // paddingLeft: "28px",
                        // paddingRight: "28px",
                        paddingLeft: {
                          lg: "28px",
                          xl: "28px",
                          md: "28px",
                          xs: "0px",
                          sm: "28px",
                        },
                        paddingRight: {
                          lg: "28px",
                          xl: "28px",
                          md: "28px",
                          xs: "0px",
                          sm: "28px",
                        },
                        // border: "1px solid blue",
                        marginBottom: {
                          lg: "20px",
                          xl: "20px",
                          md: "20px",
                          xs: "8px",
                          sm: "8px",
                        },
                        fontFamily: "'Roboto', sans-serif",
                      }}
                    >
                      <Stack
                        sx={{
                          height: "auto",
                          lineHeight: {
                            lg: "22px",
                            xl: "22px",
                            md: "22px",
                            xs: "20px",
                            sm: "32px",
                          },
                          // fontSize: "18px",
                          fontSize: {
                            lg: "17px",
                            xl: "17px",
                            md: "17px",
                            xs: "16px",
                            sm: "20px",
                          },
                          fontFamily: "'Roboto', sans-serif",
                          fontWeight: {
                            lg: "400",
                            xl: "400",
                            xs: "400",
                            sm: "400",
                          },
                          color: "text.secondary",
                          // paddingLeft: "40px",
                          // paddingRight: "40px",
                          borderRadius: "8px",
                          padding: "12px",
                          // border: "1px solid blue",
                          border: "1px solid rgb(234 239 235))",
                          backgroundColor: "rgb(234 239 235)",

                          fontFamily: "'Roboto', sans-serif",
                        }}
                      >
                        Stay effortlessly connected with seamless in-app
                        browsing.
                      </Stack>
                    </Stack>

                    <Stack
                      sx={{
                        height: "auto",
                        color: "rgb(73, 72, 72)",
                        // paddingLeft: "40px",
                        // paddingRight: "40px",
                        paddingLeft: {
                          lg: "40px",
                          xl: "40px",
                          md: "40px",
                          xs: "12px",
                          sm: "40px",
                        },
                        paddingRight: {
                          lg: "40px",
                          xl: "40px",
                          md: "40px",
                          xs: "12px",
                          sm: "40px",
                        },
                        // border: "1px solid red",
                      }}
                    >
                      <Stack>
                        <Stack
                          sx={{
                            display: "flex",
                            flexDirection: "row",
                            marginBottom: {
                              lg: "20px",
                              xl: "20px",
                              md: "12px",
                              xs: "8px",
                              sm: "8px",
                            },
                          }}
                        >
                          <FaRegCircleCheck
                            style={{
                              marginTop: "4px",
                              marginRight: "10px",
                              color: "green",
                            }}
                            size={getIconSize()}
                          />{" "}
                          <Typography
                            sx={{
                              lineHeight: {
                                lg: "24px",
                                xl: "24px",
                                md: "24px",
                                xs: "20px",
                                sm: "28px",
                              },
                              // fontSize: "18px",
                              fontSize: {
                                lg: "16px",
                                xl: "16px",
                                md: "16px",
                                xs: "12px",
                                sm: "16px",
                              },
                              fontWeight: {
                                lg: "400",
                                xl: "400",
                                xs: "400",
                                sm: "400",
                              },
                              fontFamily: "'Roboto', sans-serif",
                              color: "text.secondary",
                            }}
                          >
                            Access web pages in WhatsApp.
                          </Typography>
                        </Stack>
                        <Stack
                          sx={{
                            display: "flex",
                            flexDirection: "row",
                            marginBottom: {
                              lg: "20px",
                              xl: "20px",
                              md: "12px",
                              xs: "8px",
                              sm: "8px",
                            },
                          }}
                        >
                          <FaRegCircleCheck
                            style={{
                              marginTop: "4px",
                              marginRight: "10px",
                              color: "green",
                            }}
                            size={getIconSize()}
                          />{" "}
                          <Typography
                            sx={{
                              lineHeight: {
                                lg: "24px",
                                xl: "24px",
                                md: "24px",
                                xs: "20px",
                                sm: "28px",
                              },

                              // fontSize: "18px",
                              fontSize: {
                                lg: "16px",
                                xl: "16px",
                                md: "16px",
                                xs: "12px",
                                sm: "16px",
                              },
                              fontWeight: {
                                lg: "400",
                                xl: "400",
                                xs: "400",
                                sm: "400",
                              },
                              fontFamily: "'Roboto', sans-serif",
                              display: {
                                xl: "flex",
                                lg: "flex",
                                md: "none",
                                sm: "flex",
                                xs: "none",
                              },
                              color: "text.secondary",
                            }}
                          >
                            Avoid redirects to browsers, reducing drop-offs.
                          </Typography>
                          <Typography
                            sx={{
                              lineHeight: {
                                lg: "25px",
                                xl: "25px",
                                md: "20px",
                                xs: "20px",
                                sm: "28px",
                              },

                              // fontSize: "18px",
                              fontSize: {
                                lg: "16px",
                                xl: "16px",
                                md: "16px",
                                xs: "12px",
                                sm: "16px",
                              },
                              fontWeight: {
                                lg: "400",
                                xl: "400",
                                xs: "400",
                                sm: "400",
                              },
                              fontFamily: "'Roboto', sans-serif",
                              display: {
                                xl: "none",
                                lg: "none",
                                md: "flex",
                                sm: "none",
                                xs: "flex",
                              },
                            }}
                          >
                            Avoid redirects to browsers.
                          </Typography>
                        </Stack>
                        <Stack
                          sx={{
                            display: {
                              xl: "flex",
                              lg: "flex",
                              md: "flex",
                              sm: "flex",
                              xs: "none",
                            },
                            flexDirection: "row",
                            marginBottom: {
                              lg: "20px",
                              xl: "20px",
                              md: "12px",
                              xs: "8px",
                              sm: "8px",
                            },
                          }}
                        >
                          <FaRegCircleCheck
                            style={{
                              marginTop: "4px",
                              marginRight: "10px",
                              color: "green",
                            }}
                            size={getIconSize()}
                          />{" "}
                          <Typography
                            sx={{
                              lineHeight: {
                                lg: "24px",
                                xl: "24px",
                                md: "24px",
                                xs: "20px",
                                sm: "28px",
                              },
                              // fontSize: "18px",
                              fontSize: {
                                lg: "16px",
                                xl: "16px",
                                md: "16px",
                                xs: "12px",
                                sm: "16px",
                              },
                              fontWeight: {
                                lg: "400",
                                xl: "400",
                                xs: "400",
                                sm: "400",
                              },
                              fontFamily: "'Roboto', sans-serif",
                              display: {
                                xl: "flex",
                                lg: "flex",
                                md: "flex",
                                sm: "flex",
                                xs: "none",
                              },
                              color: "text.secondary",
                            }}
                          >
                            Instant page loading for smooth interactions.
                          </Typography>
                          {/* <Typography
                            sx={{
                              lineHeight: {
                                lg: "25px",
                                xl: "25px",
                                md: "20px",
                                xs: "20px",
                                sm: "28px",
                              },
                              // fontSize: "18px",
                              fontSize: {
                                lg: "16px",
                                xl: "16px",
                                md: "16px",
                                xs: "12px",
                                sm: "16px",
                              },
                              fontWeight: {
                                lg: "400",
                                xl: "400",
                                xs: "400",
                                sm: "400",
                              },
                              fontFamily: "'Roboto', sans-serif",
                              display: {
                                xl: "none",
                                lg: "none",
                                md: "none",
                                sm: "none",
                                xs: "flex",
                              },
                            }}
                          >
                            Instant loading for smooth interactions.
                          </Typography> */}
                        </Stack>

                        <Stack
                          sx={{
                            display: "flex",
                            flexDirection: "row",
                            marginBottom: {
                              lg: "20px",
                              xl: "20px",
                              md: "12px",
                              xs: "8px",
                              sm: "8px",
                            },
                          }}
                        >
                          <FaRegCircleCheck
                            style={{
                              marginTop: "4px",
                              marginRight: "10px",
                              color: "green",
                            }}
                            size={getIconSize()}
                          />{" "}
                          <Typography
                            sx={{
                              lineHeight: {
                                lg: "24px",
                                xl: "24px",
                                md: "24px",
                                xs: "20px",
                                sm: "28px",
                              },
                              // fontSize: "18px",
                              fontSize: {
                                lg: "16px",
                                xl: "16px",
                                md: "16px",
                                xs: "12px",
                                sm: "16px",
                              },
                              fontWeight: {
                                lg: "400",
                                xl: "400",
                                xs: "400",
                                sm: "400",
                              },
                              fontFamily: "'Roboto', sans-serif",
                              display: {
                                xl: "flex",
                                lg: "flex",
                                md: "none",
                                sm: "flex",
                                xs: "none",
                              },
                              color: "text.secondary",
                            }}
                          >
                            Keep customers engaged within WhatsApp seamlessly.
                          </Typography>
                          <Typography
                            sx={{
                              lineHeight: {
                                lg: "25px",
                                xl: "25px",
                                md: "20px",
                                xs: "20px",
                                sm: "28px",
                              },
                              // fontSize: "18px",
                              fontSize: {
                                lg: "16px",
                                xl: "16px",
                                md: "16px",
                                xs: "12px",
                                sm: "16px",
                              },
                              fontWeight: {
                                lg: "400",
                                xl: "400",
                                xs: "400",
                                sm: "400",
                              },
                              fontFamily: "'Roboto', sans-serif",
                              display: {
                                xl: "none",
                                lg: "none",
                                md: "flex",
                                sm: "none",
                                xs: "flex",
                              },
                            }}
                          >
                            Customers engaged within WhatsApp.
                          </Typography>
                        </Stack>

                        <Stack
                          sx={{
                            display: {
                              xs: "none", // Hide on extra small screens
                              sm: "none", // Hide on small screens
                              md: "flex", // Show on medium and larger screens
                              lg: "none",
                              xl: "flex",
                            },
                            flexDirection: "row",
                            marginBottom: {
                              lg: "20px",
                              xl: "20px",
                              md: "12px",
                              xs: "8px",
                              sm: "8px",
                            },
                          }}
                        >
                          <FaRegCircleCheck
                            style={{
                              marginTop: "4px",
                              marginRight: "10px",
                              color: "green",
                            }}
                            size={getIconSize()}
                          />{" "}
                          <Typography
                            sx={{
                              lineHeight: {
                                lg: "24px",
                                xl: "24px",
                                md: "24px",
                                xs: "20px",
                                sm: "28px",
                              },
                              // fontSize: "18px",
                              fontSize: {
                                lg: "16px",
                                xl: "16px",
                                md: "16px",
                                xs: "12px",
                                sm: "16px",
                              },
                              fontWeight: {
                                lg: "400",
                                xl: "400",
                                xs: "400",
                                sm: "400",
                              },
                              fontFamily: "'Roboto', sans-serif",
                              display: {
                                xl: "flex",
                                lg: "flex",
                                md: "none",
                                sm: "flex",
                                xs: "none",
                              },
                              color: "text.secondary",
                            }}
                          >
                            Complete transactions directly in WhatsApp chat.
                          </Typography>
                          <Typography
                            sx={{
                              lineHeight: {
                                lg: "25px",
                                xl: "25px",
                                md: "20px",
                                xs: "20px",
                                sm: "28px",
                              },
                              // fontSize: "18px",
                              fontSize: {
                                lg: "16px",
                                xl: "16px",
                                md: "16px",
                                xs: "12px",
                                sm: "16px",
                              },
                              fontWeight: {
                                lg: "400",
                                xl: "400",
                                xs: "400",
                                sm: "400",
                              },
                              fontFamily: "'Roboto', sans-serif",
                              display: {
                                xl: "none",
                                lg: "none",
                                md: "flex",
                                sm: "none",
                                xs: "none",
                              },
                            }}
                          >
                            Complete transactions form WhatsApp chat.
                          </Typography>
                        </Stack>

                        <Stack
                          sx={{
                            display: {
                              xs: "none", // Hide on extra small screens
                              sm: "none", // Hide on small screens
                              md: "flex", // Show on medium and larger screens
                              lg: "none",
                              xl: "flex",
                            },
                            flexDirection: "row",
                            marginBottom: {
                              lg: "20px",
                              xl: "20px",
                              md: "12px",
                              xs: "8px",
                              sm: "8px",
                            },
                            // border: "3px solid red",
                          }}
                        >
                          <FaRegCircleCheck
                            style={{
                              marginTop: "4px",
                              marginRight: "10px",
                              color: "green",
                            }}
                            size={getIconSize()}
                          />{" "}
                          <Typography
                            sx={{
                              lineHeight: {
                                lg: "24px",
                                xl: "24px",
                                md: "24px",
                                xs: "20px",
                                sm: "28px",
                              },
                              // fontSize: "18px",
                              fontSize: {
                                lg: "16px",
                                xl: "16px",
                                md: "16px",
                                xs: "12px",
                                sm: "16px",
                              },
                              fontWeight: {
                                lg: "400",
                                xl: "400",
                                xs: "400",
                                sm: "400",
                              },
                              fontFamily: "'Roboto', sans-serif",
                              display: {
                                xl: "flex",
                                lg: "flex",
                                md: "none",
                                sm: "flex",
                                xs: "flex",
                              },
                              color: "text.secondary",
                            }}
                          >
                            Retain users for seamless shopping experiences.
                          </Typography>
                          <Typography
                            sx={{
                              lineHeight: {
                                lg: "25px",
                                xl: "25px",
                                md: "20px",
                                xs: "20px",
                                sm: "28px",
                              },
                              // fontSize: "18px",
                              fontSize: {
                                lg: "16px",
                                xl: "16px",
                                md: "16px",
                                xs: "12px",
                                sm: "16px",
                              },
                              fontWeight: {
                                lg: "400",
                                xl: "400",
                                xs: "400",
                                sm: "400",
                              },
                              fontFamily: "'Roboto', sans-serif",
                              display: {
                                xl: "none",
                                lg: "none",
                                md: "flex",
                                sm: "none",
                                xs: "none",
                              },
                            }}
                          >
                            Retain users for seamless shopping.
                          </Typography>
                        </Stack>
                      </Stack>
                    </Stack>

                    <Stack
                      sx={{
                        // border: "1px solid red",
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "flex-start",
                        // paddingLeft: "40px",
                        paddingLeft: {
                          lg: "42px",
                          xl: "42px",
                          md: "42px",
                          xs: "12px",
                          sm: "40px",
                        },
                      }}
                    >
                      <Button
                        variant="contained"
                        sx={{
                          display: "flex",
                          textTransform: "none",
                          borderRadius: "8px",
                          backgroundColor: "rgb(5, 78, 146)", // Initial background
                          color: "white", // Text color
                          borderColor: "rgb(5, 78, 146)", // Border same as background
                          boxShadow:
                            "0 4px 8px rgba(0,0,0,0.2), 0 1px 3px rgba(0,0,0,0.1)",

                          "&:hover": {
                            backgroundColor: "rgb(31, 133, 192)", // Hover background
                            borderColor: "rgb(31, 133, 192)", // Hover border
                          },
                        }}
                        size="large"
                        onClick={handleClick5}
                      >
                        Know more
                      </Button>
                    </Stack>
                  </Stack>
                </Stack>

                {/* image */}
                <Stack
                  sx={{
                    // border: "1px solid green",
                    height: {
                      lg: "100%",
                      xl: "100%",
                      md: "100%",
                      xs: "40%",
                      sm: "50%",
                    },
                    width: {
                      lg: "60%",
                      xl: "60%",
                      md: "50%",
                      xs: "100%",
                      sm: "100%",
                    },

                    // borderRadius: "20px", // Rounded corners for a smooth look
                    backdropFilter: "blur(12px)", // Frosted glass effect
                    backgroundColor: "rgb(234 239 235)",
                    // boxShadow: "0 8px 32px rgba(0, 0, 0, 0.2)", // Soft shadow for depth
                    // border: "1px solid rgba(255, 255, 255, 0.2)", // Subtle border for separation
                    overflow: "hidden", // Ensure internal content doesn't overflow
                    position: "relative", // Needed for shine effect
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    transition: "all 0.5s ease-in-out",

                    // Shine Effect
                    // "&::before": {
                    //   content: '""',
                    //   position: "absolute",
                    //   top: 0,
                    //   left: 0,
                    //   width: "100%",
                    //   height: "100%",
                    //   background:
                    //     "linear-gradient(45deg, rgba(255, 255, 255, 0.2) 0%, rgba(255, 255, 255, 0.5) 50%, rgba(255, 255, 255, 0.2) 100%)",
                    //   opacity: 0.6, // Adjust opacity for subtle or prominent shine
                    //   transform: "translate(-100%, -100%)",
                    //   animation: "shineEffect 3s infinite linear",
                    // },
                    // "@keyframes shineEffect": {
                    //   "0%": {
                    //     transform: "translate(-100%, -100%)",
                    //   },
                    //   "100%": {
                    //     transform: "translate(100%, 100%)",
                    //   },
                    // },
                  }}
                >
                  <Stack
                    sx={{
                      height: "100%",
                      width: "100%",
                      //   border: "1px solid green",
                      marginTop: {
                        lg: "0px",
                        xl: "0px",
                        md: "0px",
                        xs: "0px",
                        sm: "0px",
                      },
                    }}
                  >
                    <img
                      src={Webview}
                      alt="Image1"
                      style={{
                        height: "100%",
                        width: "100%",
                      }}
                    />
                  </Stack>
                </Stack>
              </Stack>
            </Box>
          </Grid>
        </Box>
      </Box>
    </Stack>
  );
};

export default MainCard;
